module.exports = {
  h5Add: {
    download: 'Download',
    downloadWarn1: 'Click on the top right corner',
    downloadWarn2: 'Choose “Open in browser”',
    tradeList1: 'Trade',
    tradeList2: 'K line',
    tradeList3: 'Introduction',
    tradeList4: 'Trade',
    tradeList5: 'Order',
    tradeList6: 'Orderbook',
    tradeMap: 'Price chart',
    warnTitle: 'Attention',
    hisRecharge: 'Deposit History',
    hisWithdraw: 'Withdraw History',
    hisToLoan: 'Loan History',
    dropDownStatus1: 'Pull to refresh',
    dropDownStatus2: 'Release to refresh',
    dropDownStatus3: ' Loading...',
    pullUpStatus1: 'Pull up to load more',
    pullUpStatus2: 'Loading...',
    pullUpStatus3: 'Loading complete',
    return: 'Return',
    buy: 'Buy',
    sell: 'Sell',
    have: 'Available',
    close: 'Close',
    callUser: 'Contact seller',
    callServer: 'Contact CUSTOMER SERVICE',
    tradeClose: 'This ad was closed',
    depth: 'Depth',
    priceChart: 'Price chart',
    eidtLeve: 'Adjust leverage',
    eidtMargin: 'Change margin',
    OrderAmount: 'Order quantity',
    QuantityInExchange: 'In return for the amount',
  },
  common: {
    reload: 'refresh',
    notData: 'No Data ',
    error_500: 'The server is busy, please try again later ',
    imgError: 'Image size is too large',
    imgFiail: 'Image upload failed',
    pageTitleText: 'Bitcoin trading platform',
    year: 'Year',
    mouth: 'Mouth',
    zhang: 'Zhang',
    time: 'Date',
    email: 'Email',
    phone: 'Phone',
    search: ' Search',
    coin: 'Currency',
    date: ['S', 'M', 'T', 'W', 'S', 'F', 'S'],
  },
  kingAdd: {
    input: 'From 10 CNY',
    buy: 'Buy now',
  },
  phoneCode: {
    A: [
      'Afghanistan +93+4',
      'Albania +355+8',
      'Algeria +213+12',
      'American Samoa +684+16',
      'Andorra +376+20',
      'Angola +244+24',
      'Anguilla +1264+660',
      'Antigua and Barbuda +1268+28',
      'Argentina +54+32',
      'Armenia +374+51',
      'Australia +61+36',
      'Austria +43+40',
      'Azerbaijan +994+31',
    ],
    B: [
      'Bahamas +1242+44',
      'Bahrain +973+48',
      'Bangladesh +880+50',
      'Barbados +1246+52',
      'Belarus +375+112',
      'Belgium +32+56',
      'Belize +501+84',
      'Benin +229+204',
      'Bermuda Islands +1441+60',
      'Bolivia +591+68',
      'Botswana +267+72',
      'Brazil +55+76',
      'Brunei +673+96',
      'Bulgaria +359+100',
      'Burkina Faso +226+854',
      'Burundi +257+108',
    ],
    C: [
      'Cambodia +855+116',
      'Cameroon +237+120',
      'Canada +1+124',
      'Cayman Islands +1345+136',
      'Central African Republic +236+140',
      'Chad +235+148',
      'Chile +56+152',
      // 'China +86+156',
      'Colombia +57+170',
      'Congo +242+178',
      'Cook Islands +682+184',
      'Costa Rica +506+188',
      "Côte d'Ivoire +225+384",
      'Cuba +53+192',
      'Cyprus +357+196',
      'Czech Republic +420+203',
    ],
    D: [
      'Denmark +45+208',
      'Djibouti +253+262',
      'Dominican Republic +1890+214',
    ],
    E: [
      'Ecuador +593+218',
      'Egypt +20+818',
      'El Salvador +503+222',
      'Estonia +372+233',
      'Ethiopia +251+231',
    ],
    F: [
      'Fiji Islands +679+242',
      'Finland +358+246',
      'France +33+250',
      'French Guiana +594+254',
      'French Polynesia +689+258',
    ],
    G: [
      'Gabon +241+266',
      'Gambia +220+270',
      'Georgia +995+268',
      'Germany +49+276',
      'Ghana +233+288',
      'Gibraltar +350+292',
      'Greece +30+300',
      'Grenada +1809+308',
      'Guam +1671+316',
      'Guatemala +502+320',
      'Guinea +224+324',
      'Guyana +592+328',
    ],
    H: [
      'Haiti +509+332',
      'Honduras +504+340',
      'Hong Kong +852+344',
      'Hungary +36+348',
    ],
    I: [
      'Iceland +354+352',
      'India +91+356',
      'Indonesia +62+360',
      'Iran +98+364',
      'Iraq +964+368',
      'Ireland +353+372',
      'Israel +972+376',
      'Italy +39+380',
    ],
    J: [
      'Jamaica +1876+388',
      'Japan +81+392',
      'Jordan +962+400',
    ],
    K: [
      'Kazakhstan +7+398',
      'Kenya +254+404',
      "Korea, Democratic People's Republic of +850+408",
      'Korea, Republic of +82+410',
      'Kuwait +965+414',
      'Kyrgyzstan +331+417',
    ],
    L: [
      'Laos +856+418',
      'Latvia +371+428',
      'Lebanon +961+422',
      'Lesotho +266+426',
      'Liberia +231+430',
      'Libya +218+434',
      'Liechtenstein +423+438',
      'Lithuania +370+440',
      'Luxembourg +352+442',
      'Rwanda +250+646',
    ],
    M: [
      'Macau +853+446',
      'Madagascar +261+450',
      'Malawi +265+454',
      'Malaysia +60+458',
      'Maldives +960+462',
      'Mali +223+466',
      'Malta +356+470',
      'Martinique +596+474',
      'Mauritius +230+480',
      'Mexico +52+484',
      'Moldova +373+498',
      'Monaco +377+492',
      'Mongolia +976+496',
      'Montserrat +1664+500',
      'Morocco +212+504',
      'Mozambique +258+508',
      'Myanmar +95+104',
    ],
    N: [
      'Namibia +264+516',
      'Nauru +674+520',
      'Nepal +977+524',
      'Netherlands +31+528',
      'Netherlands Antilles +599+530',
      'New Zealand +64+554',
      'Nicaragua +505+558',
      'Niger +227+562',
      'Nigeria +234+566',
      'Norway +47+578',
    ],
    O: [
      'Oman +968+512',
    ],
    P: [
      'Pakistan +92+586',
      'Panama +507+591',
      'Papua New Guinea +675+598',
      'Paraguay +595+600',
      'Peru +51+604',
      'Philippines +63+608',
      'Poland +48+616',
      'Portugal +351+620',
      'Puerto Rico +1787+630',
    ],
    Q: [
      'Qatar +974+634',
    ],
    R: [
      'Reunion +262+638',
      'Romania +40+642',
      'Russia +7+643',
    ],
    S: [
      'Saint Lucia +1758+662',
      'Saint Vincent and the Grenadines +1784+670',
      'Samoa +685+882',
      'San Marino +378+674',
      'Sao Tome and Principe +239+678',
      'Saudi Arabia +966+682',
      'Senegal +221+686',
      'Seychelles +248+690',
      'Sierra Leone +232+694',
      'Singapore +65+702',
      'Slovakia +421+703',
      'Slovenia +386+705',
      'Solomon Islands +677+90',
      'Somalia +252+706',
      'South Africa +27+710',
      'Spain +34+724',
      'Sri Lanka +94+144',
      'Sultan +249+736',
      'Suriname +597+740',
      'Swaziland +268+748',
      'Swedish +46+752',
      'Swiss +41+756',
      'Syria +963+760',
    ],
    T: [
      'Taiwan +886+158',
      'Tajikistan +992+762',
      'Tanzania +255+834',
      'Thailand +66+764',
      'Togo +228+768',
      'Tonga +676+776',
      'Trinidad and Tobago +1809+780',
      'Tunis +216+788',
      'Turkey +90+792',
      'Turkmenistan +993+795',
    ],
    U: [
      'Uganda +256+800',
      'Ukraine +380+804',
      'United Arab Emirates +971+784',
      'UK +44+826',
      'United States +1+840',
      'Uruguay +598+858',
      'Uzbekistan +998+860',
    ],
    V: [
      'Venezuela +58+862',
      'Vietnam +84+704',
    ],
    Y: [
      'Yemen +967+887',
    ],
    Z: [
      'Zambia +260+894',
      'Zimbabwe +263+716',
    ],
  },
  etfAdd: {
    fundRate: 'Fund Rate',
    title: 'ETF',
    dialogTitle: 'Disclaimer',
    confirmText: 'It is necessary to agree with',
    dText1: 'Dear users：',
    dText3: 'Thanks for login and use the leverage ETF products and relevant services (hereinafter “Leveraged ETF”) provided by our Exchange . Please read the instruction of Leveraged ETF and the following risk tips carefully. If you continue to use the leveraged ETF after reading the content aforesaid, it will be deemed that you agree all the content of the disclaimer, and you are fully aware of the risks of leveraged ETF and are able to bear the losses caused by it.',
    dText4: 'Please read the instruction of Leveraged ETF and the following risk tips carefully：',
    dText5: '《FAQ for Leveraged ETF》',
    dText6: 'Risk tips:',
    dText7: '1.Your purchase/selling price shall not derivate too much from the net value, otherwise you will encounter relevant losses.',
    dText8: '2.If you put the order in the opposite direction, there is a risk that the price will approach zero in extreme conditions.',
    dText9: 'Our Exchange hereby remind you that any losses incurred by the risks mentioned above shall be borne by yourself. This disclaimer, together with other agreements, statements, rules, etc. on Exchange, constitutes the entire agreement that users shall be agreed before using the services and products of Exchange.',
    sbyText1: '1. “3L" means that the price of the underlying transaction pair has increased by 1%, and the net value of the product has increased by 3%',
    sbyText2: '2. "3S" means that the price of the underlying transaction pair fell by 1%, and the net value of the product rose by 3%',
    sbyText3: '3. The net value is normally adjusted at 0 o’clock every day, and the extreme market will be adjusted in the intraday.',
    sbyText4: '4. Every leverage will charge the corresponding management fee on a daily basis',
    sbyText5: '5. Users shall pay attention to the net value of the product before trading. There is a risk that the price will approach zero in extreme conditions. Please watch out the risk in investment.',
    sbyText6: 'See more details',
    jz: 'Net Value',
    jzText1: 'Net Value For Long = Net value at the last adjustment point * [1+ 3 * (Latest spot transaction price-spot last adjustment point price) / spot last adjustment point price * 100%]；',
    jzText2: 'Net Value For Short = Net value at the last adjustment point * [1- 3 * (Latest spot transaction price-spot last adjustment point price) / spot last adjustment point price * 100%]；',
  },
  broker: {
    broker: 'Broker system',
    invitations: 'Total invitees',
    indirect: 'Direct invitees',
    myType: 'My role',
    revenue: 'Total income',
    export: 'Export document',
    promptText1: 'UID',
    promptText2: 'Phone number',
    promptText3: 'Email',
    time: 'Time',
    phoneeNumber: 'Phone number',
    email: 'Email address',
    remaid: 'Commission record',
    agentAccount: 'Position statistics',
    tier: 'Degrees',
    fee: 'Fee',
    amount: 'Commission limit',
    opera: 'Operation',
    ccNumber: 'Position',
    view: 'View',
    symbolType: 'Currency',
    type: 'Type',
    returnDetails: 'Commission Details',
    scale: 'Commission ratio',
    startTime: 'Start time',
    endTime: 'End Time',
  },
  excheif: {
    affiliate: 'Members can upgrade to general partners by sharing 20 members',
    affiliateTow: 'General partners train 10 general partners to be promoted to senior partners',
    title: 'Registration link',
    account: 'Your commission account',
    message: 'Transaction commission',
    message2: 'Cultivate bonus',
    message3: 'Current income',
    remeakerTile: 'Specific rules',
    remark: [
      'Affiliate enjoys 30% transaction fee of his direct referral',
      'Master Affiliate enjoys 30% transaction fee of his direct referral',
      "Master Affiliate enjoys 10% of his Affiliates' commission ",
    ],
    remarkTitle2: 'Early bird stage',
    remark2: [
      'Affiliate enjoys 50% transaction fee of his direct referral',
      'Master Affiliate enjoys 50% transaction fee of his direct referral',
      "Master Affiliate enjoys 25% of his Affiliates' commission ",
      'Time',
    ],
    remarkTitle3: 'Remark',
    remark3: [
      'Exchief partners enjoy the benefits of all valid users in accordance with the above percentage terms.The valid users are the members who registered the account through the partner link, authenticated by real name and generated transactions.',
      'Exchief reserves the right to change the terms of the referral program at any time due to the changing market conditions, risk of fraud, or any other factors we deem relevant.',
    ],
    tabel1: 'Account',
    tabel2: 'Income',
    tabel3: 'Referrals',
    tabel4: 'Registration date',
    preson: 'person',
  },
  pageTitle: {
    login: 'Log In ',
    register: 'Sign Up ',
    resetPass: 'Forgot password ',
    personal: 'My Account ',
    order: 'Orders ',
    assets: 'Balance ',
    trade: 'Exchange ',
    home: 'Home ',
    cms: 'Help',
    mesage: 'Message',
    noticeInfo: 'Announcement',
    otcTrade: 'Ad Details',
    otcRelease: 'Create ad',
    otcDetailOrder: 'Order Details',
    fiatdeal: 'Fiat',
    appDownload: 'APP Download',
    broker: 'Broker system',
    mining: 'Transaction mining',
    innovation: 'Innovation test area',
    contract: 'Swaps trading',
    manageFinances: 'Financial treasure ',
    manageFinancesView: 'Treasury details',
    manageFinancesOrder: 'Financial records',
    questions: 'FAQ',
    b2cFiatdeal: 'OTC',
  },
  questions: {
    title: 'FAQ',
    send: 'Submit a question',
    list: 'Question list',
    type: 'Question type',
    mess: 'Question description',
    upload1: 'Upload again',
    upload2: 'Upload attachments',
    upload3: 'Support the jpg/png/jpeg, with size no more than 5M',
    upload4: 'Uploading',
    summit: 'Confirm to submit',
    list1: 'Question time',
    list2: 'Serial number',
    list3: 'Type',
    list4: 'Description',
    list5: 'Status',
    list6: 'Operation',
    delete: 'Delete',
    details: 'Question details',
    fj: 'Attachment',
    sendType1: 'Reply from customer service staff ',
    sendType2: 'My questions',
    typeSend: 'Additional questions',
  },
  header: {
    broker: 'Broker system',
    trade: 'Exchange',
    otc: 'OTC',
    lever: 'Margin',
    co: 'Swaps',
    assets: 'Balances',
    order: 'Order',
    zh: 'Chinese',
    login: 'Log In',
    register: 'Sign Up ',
    more: 'View more ',
    moreText: 'More',
    account: 'My account',
    message: 'Message',
    set: ' Settings',
    color: 'Mode',
    userStatus: 'Account status ',
    out: 'Log Out ',
    userStatus1: 'Normal ',
    userStatus2: 'Freeze the transaction, freeze the withdrawal ',
    userStatus3: 'Freeze the transaction 3 freeze the withdrawal ',
    minings: 'Transaction mining',
    innov_tit: 'New Tokens',
    appDownLoad: 'App Download',
    market: 'Markets',
  },
  krwAdd: {
    bod: 'Date of birth',
    regst1: 'Privacy Policy',
    regst2: 'Terms of Service',
    regst3: 'Marketing advertising use consent',
    regstmust: '(Required)',
    regstother: '(Optional)',
    hometitle: 'Reminder',
    hometext1: ' ',
    hometext2: ' ',
    hometext3: ' ',
    hometext4: ' ',
    hometext5: ' ',
    hometext6: ' ',
    hometext7: 'Do not remind again',
    hometext8: 'Confirm',
  },
  personal: {
    exccAuth: {
      errorText1: 'Authorization denied. Please choose other methods to accomplish KYC.',
      text1: 'Country',
      text2: 'KYC Verification Option',
      text3: 'Manual Form Submission',
      text4: 'Proceed with SingPass',
      text5: ' ',
      text6: 'Fill in the form manually and submit the information according to the requirements of the platform.',
      text7: ' ',
      text8: 'By using your MyInfo profile data to pre-fill the KYC form, it will make the verification process smoother, and have supporting documents waived where applicable.',
    },
    exccAuthorization: {
      title: 'Please check your information, which cannot be modified after submission',
      title2: 'Myinfo Identity Verification',
      promptText1: 'Alias Name',
      promptText2: 'Gender',
      promptText3: 'Identity Card / Passport Number',
      promptText4: 'Full Name',
      promptText5: 'Nationality',
      promptText6: 'Residential Status',
      promptText7: 'Date of Birth',
      promptText8: 'Country of Birth',
      promptText9: 'Residential Address',
      promptText10: 'Mobile Number',
      promptText11: 'Mailing Address',
      promptText12: 'Source of Income',
      income1: 'Salary',
      income2: 'Investments',
      income3: 'Savings',
      income4: 'Pension',
      income5: 'Inheritance',
      income6: 'Family Financial Support',
      income7: 'Others',
      submit: 'Submit',
    },
    exccAuthForm: {
      promptText1: 'Full Name',
      promptText2: 'Gender',
      promptText3: 'Date of Birth',
      promptText4: 'Residential Address',
      promptText5: 'City',
      promptText6: 'Postal Code',
      promptText7: 'Nationality',
      promptText8: 'Identity Card / Passport Number',
      promptText9: 'Source of Income',
      text1: 'Re-upload',
      text2: 'Address Proof. Latest official doc. Name & Addr MUST match',
      text3: 'Please upload all photo in jpg/png/jpeg file format in size no more than 8MB.',
      text4: 'All the uploaded photos must be visibly clear and must not be altered or modified in any way',
      text5: 'Hats, sunglass or any other accessories that may cover your face is not allowed. Make-up is also highly not recommended.',
      text6: 'For the 3rd photo upload, you are required to hold the FRONT of your ID/passport/driving license together with a handwritten paper. The handwritten paper must include: 1) your full name, 2) submission date, 3) our web domain name and 4) a statement to declare your personal responsibility; "All behaviors on this website is performed by myself and I am aware of the relevant risks; and is willing to take all legal consequences.',
      text7: ' Proof of Address. Please upload full page of Utility Bill (e.g. Gas, Water or Electricity) or Bank Statement or Mobile/Telco Bill or Internet Bill dated within last 6 months. Ensure Full Name and Address matches.',
      text8: 'Re-upload',
      text9: 'Back of ID card / Passport Cover',
      text10: 'Re-upload',
      text11: 'Front of ID card/ Passport Information Page',
      text12: 'Re-upload',
      text13: "Selfie with ID and note 'exchange name and today's date'",
      text14: 'In the platform authentication, you need to at least',
      sex1: 'OMale',
      sex2: 'OFemale',
      text15: 'Please describe the source of income',
      text16: "Please insert date of birth in 'yyyy-mm-dd' format",
      text17: 'Example: yyyy-mm-dd',
      text18: 'KYC verification is required before trading. Please submit your KYC.',
      text19: 'KYC verification is required before any deposit or withdrawal. Please submit your KYC.',
    },
    kyc: {
      areaTitle: 'Nationality',
      area: 'Select your country or region',
      kycAuth1: 'Please scan the QR code below with your phone,open the verification page. ',
      kycAuth2: 'Take photos of both sides of the ID card,your verification will be completed after passing face recognition.',
      kycAuth3: 'QR code validity period:',
      kycAuth4: 'The QR code has expired， please refresh the page.',
      kycAuth5: 'Verification Completed',
      kycAuth6: 'Continue to complete the certification on the current interface?',
      kycAuth7: 'Already exists',
      kycAuth8: 'Please scan the QR code to complete the verification',
      kycAuth9: 'Please complete real-name certification through staff service',
      kycMin: 'Min',
      kycSec: 'S',
      type: 'Photo ID Types',
      name: 'First Name',
      fName: 'Last Name',
      text1: 'Please Note:   Two forms of identification with photo are required (passport preferred).',
      text2: ' ',
      type1: 'Passport',
      type2: 'National ID Card',
      type3: 'Driving License',
      type4: 'Other Photo ID',

      valueText1: 'ID 1 number',
      valueText2: 'ID 2 number',

      value1: 'Passport No.',
      value2: 'National ID Card No.',
      value3: 'Driving License No.',
      value4: 'Other Photo ID No.',
      Optional: 'Optional',
      require: 'Required',
    },
    krw: {
      authType: 'Korea',
      authOther: 'Foreigner',
      auth: 'Vertification',
      niceN: 'Mobile real-name verification (Korean vertification entry)',
      niceText: 'Used for platform to confirm your identity information',
      bank: 'Bank card',
      bankText: 'Can be cashed out after linking',
      authLevel: 'ID Verification',
      authLevelText: 'For your asset security, please complete the verification as soon as possible',
      account: 'Account',
      selectArea: 'Please select your nationality',
      niceConfrim: 'Vertified',
      niceConfrimTitle: 'Mobile real-name verification',
      niceConfrimText: 'Mobile real-name verification, waiting...',
      alertText: 'For the security of your account, please complete the following verification method',
      inow: 'I know it',
      alertk: 'Mobile real-name verification or identity verification',
      OTPk: 'OTP vertification',
      phonek: 'Please improve your mobile phone real-name vertification first',
    },
    krwBank: {
      addBank: 'Link bank account',
      setBank: 'Change bank account',
      userName: 'Name',
      country: 'Countries',
      bankAccount: 'Bank account number',
      bankAccountError: 'Please enter the correct bank account',
      smsCode: 'SMS verification code',
      smsCodeError: 'Please enter the 6-digit SMS verification code',
      googleCode: 'Google authentication code',
      googleCodeError: 'Please enter the 6-digit Google verification code',
    },
    label: {
      smsCodeText: ' SMS verification code',
      googleCodeText: 'Google authentication code',
      emailCodeText: 'E-mail verification code',
      newEmailCodeText: 'New e-mail verification code',
      moneyPassword: 'Trade Password',
      oldMoneyPassword: 'New trade password',
      newConfirmMoneyPassword: 'Confirm trade password',
      confirmMoneyPassword: ' Confirm new trade password',
      ipText: 'IP address',
      noteText: 'Notes',
      promptText: 'Nationality',
      errorText: 'Please select country',
      phone: 'Mobile number',
      oldPhone: 'Initial mobile number',
      newPhone: 'New mobile number',
      oldPassword: 'Initial password',
      password: 'Password',
      newPassword: 'New password',
      newPasswordAgain: 'Confirm password',
      oldEmail: 'Initial e-mail address',
      newEmail: 'New e-mail address',
      email: 'E-mail address',
      idCard: 'ID card',
      idCardNum: 'Residential Address',
      promptText1: 'Residential Address',
      passport: 'Passport',
      name: 'Name',
      inviteCode: 'Invitation code',
      inviteUrl: 'Invitation link',
      inviteQECode: 'My QR code',
    },
    tool: {
      modify: 'Change ',
      bind: 'Connect ',
      delete: 'Delete ',
      setUp: 'Settings',
      add: 'Add ',
      submit: 'Submit',
      create: 'Create ',
      view: 'View ',
      confirm: 'Confirm ',
    },
    prompt: {
      errorTextName: 'Nickname cannot be blank ',
      errorTextLength: 'The length of the nickname cannot exceed ten digits ',
      ipErrorText: 'Please enter the correct iP address ',
      copySucces: 'Copied',
      errorCode: 'Please enter a 6-digit verification code ',
      errorPhone: 'Please enter the correct mobile number ',
      errorPhoneText: 'Please enter your mobile number ',
      errorNewPhone: 'Please enter a new mobile number ',
      ipCode: 'Please enter the correct IP address ',
      noteCode: 'Please enter a comment ',
      uploading: 'Uploading ',
      uploadQrCod: 'Upload QR code image ',
      uploadQrCodAgain: 'Upload QR code image again ',
      uploadType: 'Support the jpg/png, with size less than 5M',
      warningApi: 'Please do not divulge the key to others to avoid assets loss. A single user can create up to 5 keys. It is recommended to link the IP to the key. Each key is bound with maximum 5 IP addresses, separated by commas. ',
      warningChangePhone: 'It is forbidden to withdraw coins within 48 hours after modifying the phone. ',
      warningChangePassword: 'It is forbidden to withdraw coins within 48 hours after modifying the login password. ',
      warningChangeEmail: 'It is forbidden to withdraw coins within 48 hours after modifying the email. ',
      warningPassword: 'It is not possible to withdraw coins within 48 hours after the changing the fund’s password',
      errorPasswordText: 'Please enter 8 to 20 digits, including at least two of letters, numbers or characters ',
      errorPasswordTwo: 'The two new password entries are not the same',
      errorEmailText: 'Please enter the correct email address',
      errorEmail: 'Please enter your e-mail address',
    },
    state: {
      certification: 'Start',
      certified: 'Verified',
      authentication: 'Verificating',
      closeValidatio: 'Turn off',
      openValidatio: 'Turn on',
      open: 'Opened',
      closeSuccess: 'Turn off successfully',
      openSuccess: 'Turn on successfully',
      release: 'Releasing ',
      trading: 'Trading',
      overdue: 'Overdue',
      close: 'Close',
      closed: 'Closed ',
    },
    alert: {
      title: 'Security reminder',
      button: 'Settings',
      fiatTitle: 'Fiat currency setting reminder',
      buttonOpen: 'Activate',
      certif: 'Verificate',
      text: 'For the security of your account, please open at least one verification method.',
      enforceGoogleAuth: 'Please complete the real-name verification, set the nickname and open google authentication first before adding the payment methord and setting fund password.',
      fiatText: 'Your account must be verified by your real name, also you must set a nickname, open at least one security verification method to add payment methods and set up fund’s passwords.',
      alertErrorTextGoogle: 'Link Google verification',
      alertErrorTextPhone: 'Link mobile phone verification',
      nickName: 'Nickname',
      id: 'verification',
      textOpen: 'You have to link and activate at least one payment method, only after that you can sell digital currency',
      payTypeError: [
        'Buyers only accept payment via ',
        ' Please choose and add payment method and activate it.',
      ],
    },
    dialog: {
      title: 'Change the nickname',
      name: 'Nickname',
      text: 'Please enter the nickname',
      closeAd: 'Close the ad',
      closeAdPrompt: 'Closing the ad will lead to stop the trade. Are you sure you want to close this ad?',
      blackPrompt: 'Reminder',
      blackPromptText: 'Are you sure to remove the other party from your blacklist?',
    },
    navMenu: {
      title: 'My account',
      list: {
        inviteCodeManagement: 'Invitation Code Management',
        userManagement: 'Account List',
        safetyRecord: 'Safety record',
        leaglTenderSet: 'Fiat settings',
        advertisingManagement: 'Ad Management',
        blackList: 'Blacklist',
        apiManagement: 'API management',
      },
    },
    userManagement: {
      nameError1: 'Your nickname can not be blank',
      nameError2: 'Your nickname cannot exceed ten digits',
      userName: 'Nickname',
      id: 'ID',
      securityTitle: 'Security Settings',
      otherTitle: 'Other',
      inviteLink: 'My invitation',
      securityList: {
        password: {
          text: 'Password',
          label: '***********',
        },
        idAuth: {
          text: 'Verification',
          label: 'Please start to verify your account',
        },
        email: {
          text: 'Email',
          label: 'Used when logging in, withdrawing and modifying security settings',
        },
        phone: {
          text: 'Phone number',
          label: 'Receive verification SMS that is used to withdraw, change the password or security settings',
        },
        google: {
          text: 'Google Authenticator ',
          label: 'API Secure verification when withdrawing, retrieving passwords, modifying security settings and managing API',
        },
      },
      otherList: {
        poundage: {
          text: 'Pay fees using tokens can be used for market and trading fees',
          label: 'Used as an exchange market, trading currency unit',
        },
        myInviteCod: {
          text: 'My invitation code',
          label: 'Used to invite new users',
        },
        myInvite: {
          text: 'My invitation',
          // label: '用于邀请新用户',
        },
      },
    },
    safetyRecord: {
      navTab: [
        'Login History',
        'Security Settings History',
      ],
      loginColumn: [
        'Time',
        'Type',
        'IP',
        'Status',
      ],
      settingColumn: [
        'Time',
        'Security Settings',
        'IP',
      ],
      success: 'Successful',
      failure: 'Failed ',
    },
    inviteCodeManagement: {
      title: 'Invite friends and get commission from their tradings ',
      titleText: 'Get 30% of service charge as commission on the same day.',
      showNumber: 'Number of invited',
      showCommission: 'Commission ',
      commissionWay: 'Invitation method',
      commissionRecor: 'Invite History',
      columns: [
        'Time',
        'Invited Account',
      ],
    },
    myInvite: {
      title1: 'The more you trade ',
      title2: ', the more you earn',
      title3: 'Mining with',
      title4: '100%',
      title5: 'transaction fee returns',
      my: 'My Referral',
      number: 'Invitees',
      reward: 'Referral incomes',
      profits: 'Mining rebates',
      code: 'Default referral code',
      link: 'Default referral link',
      invite: 'Refer Now',
      details: 'Referral details',
      myReward: 'Income',
      list: 'Referral list',
      profitsList: 'Mining rebates',
      time: 'Registration date',
      user: 'Email',
      status: 'Status',
      miningDetails: 'Mining details({coin})',
      miningRewards: 'Mining rebate({coin})',
      statusItem1: 'unissued',
      statusItem2: 'issued',
    },
    leaglTenderSet: {
      title: 'Payment Management',
      titleList: [
        {
          text: 'Payment Method setting',
          label: 'Please be sure to use your real-name account. The activated payment method will be displayed to the buyer at the time of the transaction, and up to 3 types can be activated. ',
        },
        {
          text: 'Trade Password',
          label: 'To ensure the security of your funds, please set up the trade password',
        },
      ],
    },
    setUp: {
      title1: 'Set up the payment method',
      title2: 'Add a payment method',
      hint: 'Each fiat currency can be bound to a bank card, up to 4 bank cards',
      paymentMethods: {
        text: 'Payment Method',
        errorText: 'Please choose the payment method',
        text2: 'fiat currency',
        errorText2: 'Please select fiat currency type',
        paymentsWA: {
          name: 'Name',
          title: 'Account',
          type: 'account type',
        },
        paymentsCard: {
          name: 'Name',
          bank: 'Bank Name ',
          branch: 'Branch Info (optional) ',
          account: 'Bank Account ',
        },
      },
    },
    advertisingManagement: {
      navTab: [
        ' Buy ad',
        'Sell ad',
      ],
      columns: [
        'Time',
        'ID',
        'Currency',
        'Price',
        'Amount',
        'Status',
      ],
    },
    blackList: {
      title: 'Blacklist',
      columns: [
        'User',
        'Credit value',
        'Trade history',
        'Trades',
        'Operation',
      ],
      closeText: 'Remove from the blacklist',
    },
    APImanagement: {
      navTab: [
        'Create API Key',
        'API  Quotation Document',
        'API Transaction Document',
      ],
      columns: [
        'Notes',
        'Connect IP Address',
        'APIKey',
        'SecretKey',
        ' Operation',
      ],
      columnsApi: [
        'Interface',
        'description',
      ],
      recordTitle: 'API record',
      downloadDocumen: 'Download the document',
      titleText: 'Confirm the key',
      secretKey: 'SecretKey',
      APIKye: 'APIKey',
      ip: 'IP address',
      note: 'Notes',
      apiList: [
        'Get K Line Data',
        'Transaction Record',
        'Query Order Depth',
        'Get all orders ',
        'Get all transaction records',
        'Cancel order',
        'Query all transaction pairs and the degree of accuracy supported by the system ',
        'Create Order',
        'Get the latest transaction price for all currency pairs',
        'Get current order',
        'Get order details',
        'Asset balance',
      ],
    },
    checkApi: {
      title: 'View SecretKey',
    },
    modifyApi: {
      title: 'Modify APIKey',
    },
    changePhone: {
      title: 'Change the phone number',
    },
    changePassword: {
      title: 'Modify login password',
    },
    changeEmail: {
      title: 'Modify e-mail',
    },
    bindEmail: {
      title: 'Link e-mail',
    },
    bindGoogle: {
      title: 'Link Google authentication ',
      downloadGoogle: [
        'APP Download Google Authenticator APP',
        'iOSApp Store“Authenticator”iOS users Login to the App Store to search for "Authenticator" downloads.”To Login, the Android users need use the app store or a mobile phone browser to search for "Google Authenticator" downloads',
      ],
      useGoogle: [
        'Scan a QR code with Google Authenticator or enter the key manually ',
        'Open Google Authenticator, scan the QR code below or enter the following key manually to add a verification token',
      ],
      bindGoogle: [
        'Complete linking ',
        'The key is used to retrieve the Google Authenticator when the phone is replaced or lost. Be sure to save the above key backup before binding. ',
      ],
      appStore: 'App Store',
      googlePlay: 'Google Play',
      android: 'Android',
    },
    bindPhone: {
      title: 'Link the mobile phone',
    },
    closeGoogle: {
      title: 'Close Google authentication ',
    },
    closePhone: {
      title: 'Close the mobile phone verification',
    },
    idAuth: {
      title: 'Verification',
      info: 'Basic Information',
      uploadDocuments: 'Upload Documents',
      submitted: 'Submitted',
      promptTextType: 'Document type',
      next: 'Next',
      uploadIdCardPositive: 'Face of your ID 1',
      uploadIdCardPositiveAgain: 'Upload the front side of the photo once again',
      uploadIdCardBack: 'Back of your ID 1(Passport  does not need to provide back )',
      uploadIdCardBackAgain: 'Upload the back side of the photo once again',

      uploadIdCardPositive2: 'Face of your ID  2',
      uploadIdCardPositiveAgain2: 'Upload the front side of the photo once again',
      uploadIdCardBack2: 'Back of your ID 2',
      uploadIdCardBackAgain2: 'Upload the back side of the photo once again',

      uploadIdCardPersonalPositiv: 'Selfie with Photo ID',
      uploadIdCardPersonalPositivAgain: 'Upload the ID and personal signature photo once again ',

      uploadAddress: 'Proof of Residence ',

      uploadPassportPositive: 'Upload the front cover of the ID document ',
      uploadPassportPositiveAgain: 'Upload the front cover of the passport once again ',
      uploadPassportBack: 'Upload the ID document personal information page ',
      uploadPassportBackAgain: 'Upload the passport personal information page once again ',

      uploadPassportPersonalPositiv: 'Selfie with Photo ID',
      uploadPassportPersonalPositivAgain: 'Selfie with Photo ID once again ',

      uploadText: [
        'Two forms of identification with photo are required (passport preferred).',
        'Identity Cards must have photo with both sides copied. Please provide official English translation for Non-Roman Letters.',
        'If you do not have two forms of photo ID, please upload a single valid form of photo ID in two sections to complete the form; a Skype video or Hangout call could be arranged with the Compliance Team once all sections of the form have been populated.',
        "Please provide a photo of you holding your passport or photo ID. In the same picture have a reference to Cobidex and today's date displayed — a note with the word 'Cobidex', today's date, and your signature will do. Make sure your face will be clearly visible and that all passport details are clearly readable.",
        'Proof of address (a statement such as a utility bill, letter from a government dept., tax statement outside of your banking information no older than 90 days - clearly indicating your name and residential address. The document must be in Roman Lettering, or a certified English translation should be uploaded in addition to the original document.',
        'Accepted document types: JPG /PNG/JPEG, and the maximum size of the files is 8M',
      ],
      wait: [
        'Your identity information has been submitted',
        'Please wait patiently, your information is being reviewed.',
      ],
      step1: '1. Please download the mobile APP and complete the real-name authentication operation in the APP.',
      step2: '2. Open the personal center in the APP in the mobile phone and follow the prompts to complete the authentication steps.',
      appDownLoad: 'Scan code to download APP',
    },
    modifySettings: {
      setTitle: 'Set up the trade password',
      modifyTitle: 'Modify the trade password',
    },
  },
  fiatdeal: {
    title: 'Fiat',
    openA: [
      'More',
      'Fewer',
    ],
    navList: [
      'Buy/Sell',
      'Buy',
      'Sell',
      'Trade',
      'Buy',
      'Sell',
      'Publish ad',
      'Apply Merchant ',
    ],
    center: {
      header: {
        text: 'Average Price ',
      },
      country: 'Countries',
      fiat: ' Fiat currency',
      payment: 'Payment Method',
      idinfo: 'Before you start trading, you need to improve the necessary identity information. ',
      columns: [
        'Currency ',
        'Amount',
        'Limits',
        'Price',
        'Payment Method',
        'Operation',
      ],
      buy: 'Buy ',
      sell: 'Sell ',
      trading: 'Trading ',
      credit: 'Credit ',
      all: 'All ',
    },
  },
  stranger: {
    addBlackList: 'Add to the BlackList ',
    removeBlackList: 'Remove from the BlackList ',
    online: ' Online',
    offline: 'Offline ',
    already: 'Already ',
    never: 'Never',
    phone: 'Mobile',
    identity: 'ID',
    certification: 'Vertification ',
    headerList: [
      'Trades',
      'Total number of complaints',
      'Won amount',
    ],
    blackListPrompt: [
      'Are you sure you want to add the other party to the blacklist? ',
      'Are you sure you want to remove the other party from the blacklist? ',
    ],
    navTab: [
      'Buy ad',
      'Sell ad',
    ],
    columns: [
      'Currency',
      'Amount',
      'Limit',
      'Price',
      'Payment method',
      'Operation',
    ],
    buy: 'Buy ',
    sell: 'Sell ',
    view: 'View ',
  },
  home: {
    more: 'More',
    searchSy: 'Search',
    market: 'Markets ',
    close: 'Last Price ',
    applies: 'Change',
    height: 'High',
    low: 'Low',
    H_volume: '24hr Vol',
    H_turnover: '24hr Turnover ',
    marketSet: 'Favorites',
    chart: 'Chart',
    moreMarket: 'View More Market',
    bitsgtitle1: 'Any currency you want',
    bitsgtitle2: 'Popular currencies',
    bitsgtitle3: 'To trade',
    H_coNumber: 'Position',
    tab_USDT: 'USDT Margin',
    tab_USD: 'Token Margin',
  },
  trade: {
    dataType1: 'Original',
    dataType2: 'TradingView',
    dataType3: 'Depth',
    datatext1: 'O',
    datatext2: 'High',
    datatext3: 'Low',
    datatext4: 'C',
    datatext5: 'VOL',
    unlockTrade: 'Unlock',
    noUnlock: 'Deposit locked',
    freeUnlock: '赠送未解锁',
    ySellVol: 'Available balance',
    unlockSellBtn: 'Flash Sell',
    modelInfo: ' Instruction',
    sellAll: 'See all',
    balance: 'Available balance',
    currencyNotesModal: {
      coinType: 'Currency abbreviation',
      fullNameCurrency: 'Currency name',
      issueTime: 'Issuance time',
      totalIssueAmount: 'Issuance gross',
      totalCirculation: 'Circulation gross',
      officialWebsite: 'Official website',
      blockQuery: 'Block query',
      Introduction: 'Introduction',
      relatedLinks: 'Related Links',
    },
    searchSy: 'Search',
    market: 'Markets',
    close: 'Last Price',
    applies: 'Change',
    height: 'High',
    low: 'Low',
    vol: 'Volume ',
    H_volume: '24hr Vol',
    H_turnover: '24hr Turnover ',
    marketSet: 'Favorites',
    maincon: 'Main area',
    halving: 'Halving',
    newcon: 'New area',
    seecon: 'Observation Area',
    unseal: 'Unlock area',
    notData: 'No Records',
    handicap: 'Orderbook',
    latestDeal: 'Recent Trades',
    price: 'Price ',
    number: 'Amount ',
    total: 'Sum',
    time: 'Time ',
    activeOrder: 'Open orders',
    historyOrder: 'Order history',
    class: 'Category',
    transaction: 'Pair',
    average: 'Average Price',
    status: 'Status',
    opera: 'Action',
    deal: 'Executed',
    noDeal: 'Cancelled',
    turnover: 'Total',
    serviceCharge: 'Fee',
    marketPrice: 'Markets',
    cancelOrder: 'Cancel',
    cancelled: 'Cancelled successfully ',
    view: 'Detail ',
    dealMoney: 'Total',
    limitPriceTrade: 'Limit',
    marketPriceTrade: 'Markets',
    total_money: 'Estimated Value',
    buy: 'Buy ',
    sell: 'Sell ',
    loginReg: 'Log In or Sign Up',
    mPriceBuy: 'The best market price',
    mPriceSell: 'The best market price',
    pleaseLogin: 'Please login first',
    pleasePrice: 'Please enter the price',
    pleaseInput: 'Please enter',
    inputError: 'Incorrect input',
    dealCussess: 'Ordered successfully',
    full: 'Full screen',
    outFull: 'Exit full screen moden',
  },
  message: {
    mesage: 'Message Center',
    noticeInfo: 'Announcement Center',
    help_center: 'Help Center',
    selectAll: 'Select all',
    delete: 'Delete ',
    readAll: 'Mark all as read',
    pleSelContent: 'Please select the content to delete ',
    search: 'Search',
  },
  application: {
    policy: {
      title: 'Merchant verification agreement',
      desc: 'Global fiat currency trading service - OTC platformIn order to protect the security of both parties and enhance the credibility of the registered users of our OTC platform, the platform provides you with merchant vertification services. You are required to provide necessary real-personal information to complete the vertification. The platform has the right to take all legal measures to verify the information you provide. However, due to the virtual nature of the network environment and the limitation of verification methods, the platform does not guarantee the accuracy and authenticity of the certified merchants’ identity.<br/>The relevant provisions of all the contents of this agreement are closely related to your rights and obligations, please read all the contents of this agreement carefully before you start applying for vertification. Once you begin the vertification process, you are aware of and fully understand and agree to accept the entire contents of this agreement.<br/>Ⅰ. Definition and change of certification services<br/>1. The vertification service is such a service where merchants enjoy certain privileges and undertake certain obligations in the platform after merchants provide authentic and credible identity information and pay a certain amount of security deposit. Unless there is a statutory situation or otherwise agreed in this agreement, once you have completed the vertification on the platform, the corresponding identity information and certification results will not be modified or cancelled for any reason; if your identity information has changed after the vertification is completed, You should provide the platform with the vertificate issued by the corresponding department, and the platform will help you to change your certification information.<br/>In order to provide better service and secure transaction security, the platform has the right to modify or adjust the contents of this agreement according to the changes in subjective and objective conditions, and announces the changed text of this agreement by the platform without separate notification. After making any modifications or changes to this agreement, you will continue to use the services provided by the platform, that is, you have read, understood and agreed to accept the contents of the changed agreement; If you do not agree with the content of the changed agreement, you should immediately apply to disable the vertification service to the platform.<br/>Ⅱ. The merchant rights of vertification<br/>1. The platform will provide a unique vertification merchant mark to the merchant successfully applying for vertification, and the mark can distinguish between the uncertified merchant on the platform;<br/>2. Publish the transaction advertisement information that meets the requirements on the platform.<br/>Ⅲ. Required information and deposit for vertification<br/>1. Personal information of the merchant: Please complete the attachment business application information and upload.<br/>2. Asset security deposit: Merchant applying successfully for vertification should pay a certain deposit to the platform. The deposit will be transferred to the deposit account to which the certified merchant belongs. The certified merchant cannot process or transfer funds in the account within a certain period of time.<br/>Ⅳ. The use of vertification materials<br/>Report of vertification materials: the vertification materials that you submit to the platform at the time of vertification, that is, irrevocably authorize to be retained by this platform. Except as required by law or as agreed in this agreement, the platform promises not to edit or publish your certification materials to any third party and not to use it for commercial purposes, except in the following cases:<br/>1. You authorize the relevant information published by the platform;<br/>2. The platform provides to the national judicial and administrative organization;<br/>3. The platform provides to affiliates of the platform;<br/>4. When the third party and the platform provide services to users together, the third party provides you with the relevant information required for the service (excluding your bank account information);<br/>5. Based on the need to resolve your civil dispute with the third party, the platform has the right to provide your identity information to the third party.<br/>Ⅴ. About the use of deposit<br/>Deposit is used to secure the related transactions on the platform. If you have a dispute during the transaction and you are determined to be responsible for the dispute and carry out the corresponding behavior, and you do not cooperate, the platform has the right to deal with the deposit, including but not limited to detention, freezing, or paying directly to your counterparty.<br/>Ⅵ. Links to the third party websites<br/>In order to achieve identity information review, the platform may include links to the third party websites (such as online banking websites) ',
    },
    applyCompany: 'Merchant application',
    applyCompanyDesc: 'Become a merchant and enjoy more trading privileges.',
    serviceList: [
      {
        title: 'Security ',
        desc: 'Every merchant information is strictly confidential and is never Divulged',
      },
      {
        title: 'Publish ad',
        desc: 'Merchants can freely post advertisements, that is making trading more flexible and convenient',
      },
      {
        title: 'Exclusive logo ',
        desc: 'The exclusive v logo that is displayed after the merchant name will enhance the trust of the transaction party.',
      },
      {
        title: 'One-on-one service ',
        desc: 'We will provide one-to-one exclusive services to merchants',
      },
    ],
    congratulate: 'Congratulations, you have passed the verification and become a merchant',
    congratulateSuper: 'Congratulations, you have passed the verification and become a super merchant ',
    applyBtn: 'Apply now',
    applyBtnSuper: 'Apply for the super merchant status',
    relieve: ' Cancel verificate',
    confirm: 'Confirm',
    cancel: 'Cancel',
    agree: ' I have read and agreed',
    agreePolicy: '《Merchant verification agreement 》',
    relieveing: 'Canceling ',
    dialogDesc: 'After the cancel of the verification you will not be able to post ads, are you sure you want to cancel it? ',
    stepProgress: [
      {
        text: 'Waiting for the application ',
        status: 0,
      },
      {
        text: 'In the process of application ',
        status: 1,
      },
      {
        text: 'Completed',
        status: 3,
      },
    ],
    applyRegion: {
      options: [
        'Agree to freeze',
        'Used as a merchant deposit',
      ],
      applyBtn: 'Apply',
      applingBtn: 'In the process of application',
      appliedBtn: 'Return',
      cancelBtn: 'Cancel application',
      focus: 'Attention ',
      focusContent: 'You must become a super merchant to be able to place advertisement in the trading areas. The merchant can apply to become a super merchant if he or she has a high transaction efficiency, good reputation and agree to pay a large margin.  ',
      focusContentSuper: 'The merchant can apply to become a super merchant if he has high transaction efficiency, good reputation and agree to pay a large margin. ',
    },
    company: {
      head: {
        title: 'Learn about how to become a merchant. ',
        desc: 'Please follow the steps below to complete the application conditions',
        titleAppling: 'Please wait patiently during applying',
        titleApplied: 'Congratulations, you have become a merchant',
        descApplied: 'You can enjoy the following trading privileges',
      },
      unApply: {
        stepOne: {
          title: 'Step 1 Prepare the following materials as required',
          desc: [
            '1.Please download',
            'Application information template',
            '，Fill in the application materials as required',
            '<br/>Please record a video, the video requirements are as follows: hand-held ID card front side, continue video recording, keep the sound and images clear during recording <br/> Video reading template: person (name), ID number (ID number), the source of my funds is legal and reliable, I voluntarily trade digital assets such as Bitcoin, I fully understand the digital currency and potential risks, I have the ability to resist risks and willing to bear all risks!',
          ],
        },
        stepTwo: {
          title: 'Step 2 Send an application email',
          desc: [
            'Please send the above application materials and video materials by e-mail to',
            'The subject of the email should be "Apply for becoming a merchant',
          ],
        },
        stepThree: {
          title: 'Step 3 Submit an application ',
          desc: [
            'After sending the e-mail, please click the "Confirm Application" button on this page to submit your application. And also agree to freeze ',
            'Used as a merchant deposit. When the submission is complete, you can post your ad in the normal trading area ',
          ],
        },
        stepFour: {
          title: 'Step 4 Data verification ',
          desc: [
            'We will check your merchant application information within 3 working days, please keep your communication as usual, we will get in touch with you on our own initiative. ',
          ],
        },
      },
      applying: {
        desc: '1.The application was submitted successfully and your information is under review. <br/><br/>  2. Your cash deposit has been frozen. <br/><br/> 3. You have submitted your application. If the information is submitted correctly, our staff will approve it within 3 working days.',
      },
      applied: {
        desc: '1. Merchants can freely post ads to make business more flexible and convenient. <br/><br/> 2. The exclusive v logo that is displayed after the merchant name will enhance the trust of the transaction party. <br/><br/> 3. We will provide one-to-one exclusive services to merchants ',
      },
    },
    companySuper: {
      head: {
        title: 'How to become a super merchant？',
        desc: 'Please follow the steps below to meet application requirements',
        titleAppling: 'Please wait patiently, your information is being reviewed',
        titleApplied: 'Congratulations, you have become a super merchant',
        descApplied: 'You can enjoy the following trading privileges',
      },
      unApply: {
        stepOne: {
          title: 'Step 1 Submit an application ',
          desc: [
            'Please click the "Apply for becoming a merchant" button on this page. And also agree to freeze',
            'Used as a merchant deposit. Once the submission is complete, you can post the trade ads.',
          ],
        },
        stepTwo: {
          title: 'Step 2 Review ',
          desc: [
            'We will check your application information within 3 working days, please keep your communication as usual, we will get in touch with you on our own initiative .',
          ],
        },
      },
      applying: {
        desc: '1.The application was submitted successfully and your information is under review. <br/><br/> 2. Your cash deposit has been frozen. <br/><br/> 3. You have submitted your application. If the information is submitted correctly, our staff will approve it within 3 working days.',
      },
      applied: {
        desc: '1. Super merchants can freely post advertisements in any area,  that is making trading more flexible and convenient. <br/><br/> 2. The exclusive v logo that is displayed after the merchant name will enhance the trust of the transaction party. <br/><br/> 3. We will provide one-to-one exclusive services to merchants.',
      },
    },
    unEnough: 'Insufficient Fiat balance available for account',
  },
  login: {
    WelcomeToLogin: 'Log In',
    NotRegisteredUsersYet: 'No Account? ',
    goRegister: 'Sign Up',
    phoneOrEmail: 'Email or phone number',
    formatIncorrect: 'The input format is incorrect',
    password: 'Password ',
    passwordError: 'Please enter 8 to 20 digits, including at least two of letters, numbers or characters',
    VerificationMode: 'Verification mode ',
    AuthenticationMethod: 'Please select the verification method ',
    ForgetPassword: 'Forgot Password?',
    login: 'Log in ',
    SecurityVerification: 'Security Verification ',
    MailboxValidation: 'Email Verification ',
    MobilePhoneVerification: 'SMS Verification ',
    GoogleAuthenticator: 'Google Verification ',
    googleCodeError: 'Please enter a 6-digit Google verification code',
    phoneCodeError: 'Please enter a 6-digit mobile phone verification code',
    emailCodeError: 'Please enter a 6-digit email verification code',
    codeError: 'Please enter a 6-digit  verification code ',
    googleCode: 'Google verification code ',
    phoneCode: 'SMS verification code ',
    emailCode: 'Email verification code',
    code: 'Verification code',
    loginSuccess: ' Login success',
    phoneSendSuccess: 'SMS has been sent, please check it',
    emailSendSuccess: 'The e-mail has been sent, please check it',
    loginPrompt: ' ',
  },
  register: {
    phoneRegister: 'Phone number',
    emailRegister: 'Email address',
    WelcomeToRegister: 'Welcome to register',
    AlreadyAregisteredUser: 'Already have an account?',
    logInImmediately: 'Login now',
    location: 'country ',
    PleaseSelectAcountry: 'Please select a country ',
    password: 'Password ',
    passwordError: 'Please enter 8 to 20 digits, including at least two of letters, numbers or characters',
    confirmPassword: 'Confirm the password',
    confirmPasswordError: 'The two new password entries are not the same',
    InvitationCodeError: 'Please enter the invitation code',
    IHaveReadAndAgreed: 'I have read and agreed',
    UserAgreement: 'Terms of Service',
    register: 'Sign Up',
    phone: 'Phone number ',
    phoneError: 'The phone number input format is incorrect ',
    phoneCode: 'SMS verification code ',
    phoneCodeError: 'Please enter a 6-digit SMS verification code ',
    email: 'Email address ',
    emailError: 'The email input format is incorrect ',
    emailCode: 'Email verification code',
    emailCodeError: 'Please enter a 6-digit mailbox verification code ',
    InvitationCodeOptional: 'Invitation code (optional) ',
    InvitationCodeIsRequired: 'Invitation Code ',
    registerSuccessQLogin: 'Registration success. Has logged ',
    scrollCode: 'Please complete the security verification to get the verification code.',
    phoneSendSuccess: 'SMS has been sent, please check it ',
    emailSendSuccess: 'The Email has been sent, please check it ',
    registerSuccess: 'Registration success. please Login ',
  },
  resetPass: {
    googleCode: 'Google authentication code ',
    googleError: '6Please enter a 6-digit Google authentication code',
    IDCode: 'ID number',
    IDError: 'Please enter the ID number',
    next: 'Next',
    submit: 'Submit',
    phoneReset: 'Phone number',
    emailReset: 'Email address',
    ResetLoginPassword: 'Reset password',
    ResetLoginPasswordError: 'It is forbidden to withdraw coins within 48 hours after resetting the login password',
    password: 'New password',
    passwordError: '8～20,+Please enter 8 to 20 digits, including at least two of letters, numbers or characters',
    confrimPassWord: 'Confirm password',
    confrimPassWordError: 'The two new password entries are not the same',
    phone: 'Phone number',
    phoneError: 'The phone number input format is incorrect ',
    phoneCode: 'SMS verification code ',
    phoneCodeError: 'Please enter a 6-digit SMS verification code',
    email: 'Email address ',
    emailError: 'The email format is incorrect ',
    emailCode: 'Email verification code',
    emailCodeError: 'Please enter a 6-digit mailbox verification code ',
    resetSuccess: 'The password is reset successfully, please login',
    phoneSendSuccess: 'SMS has been sent, please check it ',
    emailSendSuccess: 'The email has been sent, please check it ',
  },
  assets: {
    branchName: 'Chain name',
    hideMinAssets: 'Hide Minor Balances',
    b2c: {
      otcShow: {
        header: 'OTC',
        fiatTitle: 'OTC Set reminder',
        leaglTenderSet: 'OTC Set',
        fiatdealTitle: 'OTC',
        goHall: 'Back',
        unEnough: 'OTC  Account Insufficient balance',
        otcAccount: 'OTC  Account',
        lagel: 'Fiat',
        otcOrder: 'OTC Order',
        otcTradeWarning: 'To ensure the safety of funds, the purchased assets will be locked and can not be operated, such as withdrawing and OTC selling until 24 hours later. Meanwhile, transactions and other businesses will not be affected.',
      },
      lagel: 'fiat',
      allName: 'Full name',
      recrgeTitle: 'deposit account',
      rechargeSum: 'deposit amount',
      rechargeMin: 'Note: single deposit shall not be less than',
      voucherTit: 'Transfer voucher',
      voucherWarn: 'Upload your deposit record after offline transfer',
      voucherCli: 'Upload deposit voucher',
      bankName: 'Bank name',
      bankSub: 'branch',
      cardNo: 'Card number',
      name: 'Payee',
      remark: 'deposit notes',
      withdrawMin: 'minimum withdrawal amount',
      withdrawMax: 'Maximum withdrawal amount',
      withdrawDay: 'Cash withdrawal amount today',
      withdrawAddress: 'withdraw account',
      fee: 'Fee',
      arrivalAccount: 'Amount of account',
      withdrawMinWarn: 'Single withdrawal amount shall not be less than',
      withdrawMaxWarn: 'Single withdrawal amount shall not be greater than',
      withdrawDayWarn: 'Cash withdrawal amount today',
      withdrawHaveWarn: 'Available balance is',
      addressMent: 'account management',
      addressAddTit: 'Add account',
      addressSetTit: 'Modify account',
      addressListTit: 'Account list',
      warning: 'Tips',
      deleteWarn: 'Delete',
      payType: 'Payment type',
      address: 'Account',
      addressUserName: 'Payee',
      bankCard: 'Bank card',
      set: 'Edit',
      firstWay: 'payment type',
      country: 'Bank',
      countrySub: 'branch',
      countryNo: 'Bank account',
      submit: 'Submit',
      b2cRecrgeHisList1: 'Number of applications',
      b2cRecrgeHisList2: 'Actual amount',
      b2cRecrgeHisList3: 'Handled Time',
      seePz: 'Evidence',
      b2cWithdrawHisList1: 'Get the sum',
    },
    krw: {
      rechargeMin: 'The recharge amount is not less than',
      rechargeAccount: 'Recharge bank account',
      rechargeUserName: 'Bank account name',
      rechargeBankName: 'Bank name',
      rechargeBankAccount: 'Bank account number',
      rechargeSum: 'Charge amount',
      rechargeConfrim: 'Recharge confirmation',
      rechargeTo: 'Recharge to the specified account',
      rechargeText: 'Transfer remarks content',
      copySuccess: 'Copy success',
      rechargeList1: 'Application time',
      rechargeList2: 'Account time',
      rechargeList3: 'Currency',
      rechargeList4: 'Recharge amount',
      rechargeList5: 'Account amount',
      rechargeList6: 'Platform account',
      rechargeList7: 'State',
      rechargeListError: 'Not arrived',
      withdrawAccount: 'Withdrawal bank account',
      withdrawUserName: 'Bank account name',
      withdrawBankName: 'Bank name',
      withdrawBankAccount: 'Bank account number',
      withdrawFee: 'Withdrawal fee',
      withdrawNum: 'Total amount',
      withdrawAuth1: 'Mobile real-name authentication or identity verification',
      withdrawAuth2: 'OTP verification',
      withdrawAuth3: 'Bound bank card',
      withdrawList1: 'Application time',
      withdrawList2: 'Account time',
      withdrawList3: 'Currency',
      withdrawList4: 'With cash amount',
      withdrawList5: 'Cost fee',
      withdrawList6: 'User bank account',
      withdrawList7: 'State',
      withdrawListError: 'Not arrived',
    },
    index: {
      title: 'Balances',
      exchangeAccount: 'Exchange Account',
      coExchangeAccount: 'Primary Account',
      addressMent: 'Address List',
      flowingWater: 'Trade History',
      otcAccount: 'OTC Account',
      otcFlowingWater: 'Trade History',
      leverage: 'Margin Account',
      coAccount: 'Swaps Account',
      bibaoAccount: 'BiBao Account',
      detail: 'View details',
    },
    leverageAccount: {
      find: 'Search',
      list1: 'Margin Account',
      list2: 'Total assets',
      list3: 'Available',
      list4: 'Freeze',
      list5: 'Lent',
      list6: 'Explosive price',
      list7: 'Risk rate',
      list8: 'Operating',
      transfer: 'Transfer',
      ToLoan: 'Loans',
    },
    leverageToLoan: {
      typeText1: 'Principal',
      typeText2: 'Interest',
      typeText3: 'Principal+Interest',
      title: 'Loans',
      can: 'Available',
      transfer: 'Transfer',
      warning: 'When the risk rate is ≤110%, the account will trigger a short position to return the borrowed funds.',
      max: 'Maximum amount',
      borrowed: 'Lent',
      rate: 'Interest rate',
      rateMark: 'The interest rate is the ratio of the interest charged by the system when applying for a loan. The interest is calculated according to the 24-hour interest rate.',
      number: 'Number of loans',
      ToLoan: 'Loans',
      listTitle: 'Recent loan record',
      list1: 'Application time',
      list2: 'Margin account',
      list3: 'Currency',
      list4: 'Quantity',
      list5: 'Interest rate',
      list6: 'Unpaid interest',
      list7: 'Unpaid quantity',
      list8: 'Operation',
      canToLoan: 'Can borrow',
      inputError1: 'The amount of borrowings must not be greater than the number of borrowables',
      inputError2: 'The amount of borrowings must not be less than',
      repayment: 'Return',
    },
    leverageTransfer: {
      title: 'Transfer of funds',
      leverageAccount: 'Margin Account',
    },
    leverageRepayment: {
      title: 'Return',
      symbol: 'Margin Account',
      coin: 'Return currency',
      Surplus: 'Should still be quantity',
      sum: 'Number of loans',
      rate: 'Interest',
      RepaymentNum: 'Return quantity',
      error1: 'The amount of return shall not be less than',
      error2: 'The returned quantity must not be greater than the available quantity',
      error3: 'The return quantity shall not be greater than the quantity to be repaid',
      can: 'Available',
    },
    lerverageFlowingWater: {
      direction: 'Direction',
      symbol: 'Margin Account',
      allCoin: 'All',
      directionAll: 'All',
      directionIn: 'Transfer to margin',
      directionOut: 'Transfer margin',
      tab1: 'Current loan',
      tab2: 'Historical lending',
      tab3: 'Transfer record',
      tab1List1: 'Application time',
      tab1List2: 'Margin Account ',
      tab1List3: 'Currency',
      tab1List4: 'Quantity',
      tab1List5: 'Interest rate',
      tab1List6: 'Unpaid interest',
      tab1List7: 'Unpaid quantity',
      tab1List8: 'Operation',
      tab2List1: 'Application time',
      tab2List2: 'Margin Account',
      tab2List3: 'Currency',
      tab2List4: 'Quantity',
      tab2List5: 'Interest rate',
      tab2List6: 'Interest',
      tab2List7: 'Status',
      tab3List1: 'Time',
      tab3List2: 'Margin account',
      tab3List3: 'Currency',
      tab3List4: 'Quantity',
      tab3List5: 'Direction',
      repayment: 'Returned',
      status1: 'Loans',
      status2: 'Partial return',
      status3: 'Return all',
      status4: 'Burst',
      status5: 'Wear a warehouse',
      status6: 'End of the burst',
      status7: 'End of the warehouse',
    },
    exchangeAccount: {
      positionBalance: 'Platform lock',
      incomeLock: 'Financial lock',
      positionV2Amount: 'Token lock',
      TotalAssets: 'Estimated Value',
      ListOfFunds: 'Coin',
      HideZeroAssets: 'Hide zero assets',
      SearchCurrency: 'Search',
      coin: 'Currency',
      lumpSum: 'Balances',
      Available: 'Available ',
      freeze: 'Frozen ',
      AssetFolding: 'Estimated Value',
      options: 'Operation',
      other: 'Other ',
      Recharge: 'Deposit ',
      withdraw: 'Withdraw ',
      position: 'Lock Position',
      limit: 'limit',
    },
    addressMent: {
      pageText: 'At the same time, you need a coin address and a tag(Memo). The tag is a numeric string that guarantees the unique address of your coin, and appears in pairs with the coin address. Please be sure to follow the correct recharge procedure and enter the complete information when withdrawing coins, otherwise the loss of coins may occur.',
      addAddress: 'Add address',
      coin: 'Currency',
      WithdrawalAddress: 'Withdrawal Address ',
      Remarks: 'Address Notes',
      label: 'Tag(Memo)',
      add: 'Add ',
      listCoin: 'Currency',
      listRemarks: 'Notes',
      listAddress: 'Address',
      listOptions: 'Operations',
      AddressList: 'Address List ',
      safetyWarning: 'Safety warning ',
      safetyWarningError: 'For the security of your account, please open at least one verification method',
      GotoOpen: 'Settings',
      safetyVerification: 'Security Verification ',
      phoneCode: 'SMS verification code ',
      phoneCodeError: 'Please enter a 6-digit mobile phone verification code',
      googleCode: 'Google authentication code ',
      googleCodeError: 'Please enter a 6-digit Google verification code',
      bindGoogle: 'Connect Google authentication ',
      bindPhone: 'Connect phone verification',
      phoneSendSuccess: 'SMS has been sent, please check it',
      delete: 'Delete ',
    },
    flowingWater: {
      coin: 'Coin ',
      type: 'Type ',
      allCoin: 'All coins ',
      RechargeRecord: 'Deposit History',
      WithdrawalsRecord: 'Withdrawal History',
      OtherRecords: 'Other History',
      RechargeTime: 'Time ',
      RechargeCoin: 'Currency',
      RechargeVolume: 'Quantity',
      RechargeNumber: 'Confirmation Number ',
      RechargeStatus: 'Status',
      withdrawTime: 'Time ',
      withdrawAddress: 'Address ',
      withdrawVolume: 'Amount',
      withdrawFee: 'Fee ',
      withdrawRemarks: 'Notes',
      withdrawStatus: 'Status',
      withdrawOptions: 'Operation',
      otherTime: 'Time',
      otherCoin: 'Coin',
      otherType: 'Type',
      otherVolume: 'Amount',
      otherStatus: 'Status',
      withUser: 'Source user',
      rechargeAddress: 'Deposit Address',
      Cancel: 'Cancel ',
      label: 'Label',
      updataAt: 'Wallet processing time',
      txid: 'Blockchain transaction ID',
      type1: 'External recharge',
      type2: 'Internal transfer',
    },
    recharge: {
      pageText: ' You need a coin address and a tag(Memo). The tag is a numeric string that guarantees the unique address of your coin, and appears in pairs with the coin address. Please be sure to follow the correct recharge procedure and enter the complete information when withdrawing coins, otherwise the loss of coins may result.',
      rechargeWarning: 'You must fill in the deposit address and tag when recharging. This is the unique identifier of your account. Failure to fill it in or fill in the wrong way will lead to the loss of your assets.',
      recharge: 'Deposit',
      rechargeError: 'Do not deposit any of the above-mentioned addresses in non-local currency assets, otherwise the assets will not be retrievable. ',
      rechargeAddress: 'Deposit Address ',
      label: 'Tag(Memo)',
      RecentRechargeRecord: 'Recent',
      RechargeReminder: 'Tips',
      lumpSum: 'Balances',
      Available: 'Available ',
      freeze: 'Freeze ',
      RechargeTime: 'Time ',
      RechargeCoin: 'Currency',
      RechargeVolume: 'Amount',
      RechargeNumber: 'Confirmation times ',
      RechargeStatus: 'Status',
      copyAddress: 'Address copied successfully ',
      copyLabel: 'Address tagged successfully ',
    },
    withdraw: {
      pageText: 'At the same time, you need a coin address and a tag(Memo). The tag is a numeric string that guarantees the unique address of your coin, and appears in pairs with the coin address. Please be sure to follow the correct recharge procedure and enter the complete information when withdrawing coins, otherwise the loss of coins may result.',
      withdraw: 'Withdraw ',
      lumpSum: 'Balances',
      Available: 'Available ',
      freeze: 'Freeze ',
      MinimumCoinLimit: 'Min Limit ',
      MaximumCoinLimit: 'Max Limit ',
      dayMaximumCoinLimit: 'Daily remaining limit',
      CoinAddress: 'Withdraw Address ',
      label: 'Tag(Memo)',
      NumberOfCoins: 'Amount',
      fee: 'Fee ',
      feeError: 'Please enter the correct fee',
      allWithdraw: 'Withdraw all ',
      buttonWithdraw: 'Withdraw',
      addAddrss: 'Add address',
      RecentWithdrawalRecords: 'Recent',
      safetyWarning: 'Tips',
      enforceGoogleAuth: 'For the security of your account, please enable security verification',
      safetyWarningError: 'For the security of your account, please open at least one verification method',
      GotoOpen: 'Settings',
      safetyVerification: 'Security Verification ',
      phoneCode: 'SMS verification code ',
      phoneCodeError: 'Please enter a 6-digit mobile phone verification code',
      googleCode: 'Google verification code ',
      googleCodeError: 'Please enter a 6-digit Google verification code',
      bindGoogle: 'Connect Google verification ',
      bindPhone: 'Connect mobile phone verification',
      withdrawTime: 'Time',
      withdrawAddress: 'Withdraw Address ',
      withdrawVolume: 'Amount',
      withdrawFee: 'Fee ',
      withdrawRemarks: 'Notes',
      withdrawStatus: 'Status',
      withdrawOptions: 'Operation',
      NumberOfCoinsError: 'Please enter the number of coins ',
      NumberOfCoinsError2: "The number of coins must be greater than the miner's fee",
      NumberOfCoinsError3: 'The number of coins cannot be greater than the available balance',
      NumberOfCoinsError4: '(Number of coins- the fee) needs to be within the maximum and minimum withdrawal amount',
      NumberOfCoinsError5: '(Number of coins- the fee) needs to be less than the current withdrawal',
      phoneSendSuccess: 'SMS has been sent, please check it',
      range: 'Range ',
      account: 'Reciprocal account(Phone/Email/UID)',
      innerList: 'Transfer records',
      transferTime: 'Transfer Time',
      transferNumber: 'Transfer amount',
      sideAccount: 'Reciprocal account',
      innerTranfer: 'Direct transfer within station',
      transfer: 'Transfer',
    },
    otcAccount: {
      TotalAssets: 'Estimated Value',
      ListOfFunds: 'Coin',
      HideZeroAssets: 'Hide zero assets',
      SearchCurrency: 'Search',
      CapitalTransfer: 'Transfer',
      coin: 'Coins',
      Available: 'Available ',
      freeze: 'Freeze ',
      options: 'Operation',
      from: 'From ',
      to: 'Transfer to ',
      exchangeAccount: 'Exchange Account',
      otcAccount: 'OTC Account',
      all: 'All',
      volume: 'The number of transfers',
      volumeError: 'Available quantity is not enough',
      can: 'Can be transferred',
      other: 'Other ',
      optionCapitalTransfer: 'Capital Transfer',
    },
    otcFlowingWater: {
      title: 'History',
      type: 'Type',
      coin: 'Currency',
      all: 'All ',
      allCoin: 'All coins ',
      inOtc: 'Transfer in',
      outOtc: 'Transfer out',
      listTime: 'Time',
      listCoin: 'Currency',
      listType: 'Type',
      listVolume: 'Amount',
    },
    coAccount: {
      quota: 'Account Balance',
      transfer: 'Fund transfer',
      totel: 'Available Balance',
      accountRight: 'Account Equity',
      orderMargin: 'Order Margin',
      positionMargin: 'Position Margin',
      unrealisedAmount: 'Pending Profit and Loss',
      listTitle: 'Transaction History',
      useMarginRate: 'Margin has been used',
      coAccount: 'Swaps Account',
      list1: 'Swaps',
      list2: 'Quantity',
      list3: 'Realized P/L',
      list4: 'Unrealized P/L',
      list5: 'Operation',
      type1: 'Perpetual',
      type2: 'This Week',
      type3: 'Next Week',
      type4: 'Monthly',
      type5: 'Quarterly',
    },
    coFlowingWater: {
      list1: 'Time',
      list2: 'Type',
      list3: 'Quantity',
      list4: 'Symbol',
      list5: 'Swaps Account',
    },
    bibaoAccount: {
      bibaoAccount: 'BiBao Account',
      coin: 'Coin Currency',
      lumpSum: 'Total',
      quota: 'Balance',
      bibao: 'BiBao',
      opera: 'Operation',
      transfer: 'Transfer in',
      detail: 'Details',
      bibaoDetail: 'View details',
      transferNum: 'Transfer in amount',
      freed: 'Free',
      startTime: 'Start time',
      endTime: 'Due time',
      status: 'Status',
    },
  },
  order: {
    index: {
      title: 'Order Center',
      exOrder: 'Exchange Order',
      otcOrder: 'OTC Order',
      leverage: 'Margin Order',
    },
    exchangeOrder: {
      all180: 'All (last 180days)',
      haveCancel: 'Cancelled Order',
      type: 'Type',
      symbol: 'Pair',
      market: 'Markets',
      coin: 'Coin',
      nowOrder: 'Open Order',
      hisOrder: 'Order History',
      all: 'All ',
      buy: 'Buy ',
      sell: 'Sell ',
      nowOrderTime: 'Time',
      nowOrderType: 'Type',
      nowOrderPrice: 'Price',
      nowOrderVolume: 'Amount',
      nowOrderTotol: 'Total',
      nowOrderAverage: 'Average Price',
      nowOrderTransaction: 'Executed/Unexecuted',
      nowOrderOptions: 'Operation',
      hisOrderTime: 'Time',
      hisOrderType: 'Type',
      hisOrderPrice: 'Price',
      hisOrderVolume: 'Amount',
      hisOrderAverage: 'Average Price ',
      hisOrderStatus: 'Status',
      hisOrderOptions: 'Operation',
      marketPrice: 'Markets',
      cancel: 'Cancel ',
      details: 'Details ',
      detailsTime: 'Time',
      detailsPrice: 'Price',
      detailsVolume: 'Amount',
      detailsTotol: 'Volume of business ',
      detailsFee: 'Fee',
    },
    otcOrder: {
      haveCancel: ' Show cancelled orders',
      coin: 'Currency',
      allCoin: 'All currencies',
      nowOrder: 'Open Order',
      hisOrder: 'Order History',
      all: 'All',
      buy: 'Buy',
      sell: 'Sell',
      nowOrderId: 'No.',
      nowOrderType: 'Type',
      nowOrderCoin: 'Currency',
      nowOrderPirce: 'Price',
      nowOrderVolume: 'Amount',
      service: 'fee',
      nowOrderTotol: 'Transaction amount',
      nowOrderStatus: 'Status',
      nowOrderUser: 'Conterparty',
      hisOrderId: 'No.',
      hisOrderType: 'Type',
      hisOrderCoin: 'Coin',
      hisOrderPirce: 'Price',
      hisOrderVolume: 'Amount',
      hisOrderTotol: 'Transaction amount',
      hisOrderStatus: 'Status',
      hisOrderUser: 'Transaction party',
    },
    coOrder: {
      coOrder: 'Swaps Order',
      type: 'Type',
      contract: 'Swaps',
      nowList1: 'Time',
      nowList2: 'Swaps',
      nowList3: 'Quantity',
      nowList4: 'Order Price',
      nowList5: 'Filled',
      nowList6: 'Remaining',
      nowList7: 'Order Value',
      nowList8: 'Average Price',
      nowList9: 'Type',
      nowList10: 'Status',
      nowList11: 'Swaps',
      hisList1: 'Time',
      hisList2: 'Swaps',
      hisList3: 'Quantity',
      hisList4: 'Order Price',
      hisList5: 'Filled',
      hisList6: 'Average Price',
      hisList7: 'Type',
      hisList8: 'Status',
      status1: 'New Order',
      status2: 'Complete Deal',
      status3: 'Partial Deal',
      status4: 'Cancelled',
      status5: 'Revoked',
      status6: 'Deprecated',
      status7: 'Partial transaction has been revoked',
      orderType1: 'Perpetual',
      orderType2: 'This Week',
      orderType3: 'Next Week',
      orderType4: 'Monthly',
      orderType5: 'Quarterly',
      infoOrder: 'Limit',
      marketOrder: 'Markets',
      cancel: 'Withdrawal',
    },
  },
  otcRelease: {
    title: 'Publish a trading ad ',
    text1: 'If you trade this currency frequently, you can post your own trading ad. If you only want to buy or sell once, we recommend you to place an order directly from the purchase or sale list.',
    text2: 'If you post a sale ad, please ensure that your account balance is sufficient.',
    text3: 'The user who publishes the transaction advertisement needs to pay a part of the fee for each completed transaction; the specific cost is subject to actual conditions',
    text4: 'According to the market price, the transaction price can be flexibly changed according to the market conditions, and the fixed price cannot be changed.',
    text5: 'We suggest you to communicate about all matters only on this site to avoid unnecessary risks',
    type: 'Type',
    buy: 'Buy ',
    sell: 'Sell ',
    currency: 'Currency type',
    currencyError: 'Please select currency type',
    volume: 'Available',
    Surplus: 'Surplus',
    CurrentUnitPrice: 'Price',
    ReferenceWebSite: 'Reference Website',
    PricingMethod: 'Pricing Method',
    PricingMethodError: 'Please select currency type',
    CustomPrice: 'Custom Price',
    TotalSum: 'Total',
    MinimumQuota: 'Min Limit',
    MaximumQuota: 'Max Limit',
    min: 'Minute',
    TimeLimitForPayment: 'Time Limit for the Payment ',
    MinimumNumber: 'The minimum number of transactions of the other party',
    frequency: 'Frequency',
    FailureTime: 'Failure Time',
    FailureTimeError: 'Please select the failure time',
    PaymentMethod: 'Payment method ',
    PaymentMethodWarning: 'Select up to 3 payment methods',
    Receivables: 'Receipt method',
    ReceivablesWarning: 'You can choose several payment methods',
    PaymentError: 'You have not chosen the payment method yet, please go to the personal center settings',
    AutomaticRecovery: 'Automatic Recovery (Optional)',
    AdvertisingMessage: 'Advertising message (Optional)',
    submit: 'Publish an ad',
    Reminder: 'Reminder',
    AnotherOne: 'Send another one',
    goHall: 'Return to the advertising hall',
    success: 'Congratulations, the ad was successfully published',
    SafetyTips: 'Safety Tips',
    MarketPrice: 'Market Price (premium) ',
    Custom: 'Custom ',
    PleaseEnterQuantity: ' Please enter the quantity',
    availableBalance: 'Available balance is not enough',
    minPriceError1: 'The minimum limit cannot be greater than the total amount',
    minPriceError2: 'The minimum limit cannot be greater than or equal to the maximum limit',
    maxPriceError1: 'The maximum limit cannot be greater than the total amount',
    maxPriceError2: 'The maximum limit cannot be less than or equal to the minimum limit',
    paymentTimeLimit: 'Please enter the payment time limit',
    paymentTimeError: ' The payment time limit should be 5-60 minutes',
    jurisdictionTitle: 'Please complete the real-name vertification, set up the nickname first, then you can publish the advertisement',
    jurisdictionTitle2: 'Please complete the real-name vertification, set up the nickname and apply to become a merchant to post ads',
    authentication: 'Real-name verification',
    DeCertification: 'Go to verificate',
    SetNickname: 'Set up the nickname',
    ToSetUp: 'Go to settings',
    ApplicationMerchant: 'Apply for a merchant status',
    ToApply: 'Go to apply',
    threePayment: 'You can choose up to three payment methods',
    day: 'Day ',
    higher: 'Above the reference price',
    lower: 'Below the reference price',
    precent: 'Premium price',
    des: "Comprehensive references on the mainstream exchange and Stock quotes' real-time exchange rate, Update at regular time",
    precentWay: 'Premium direction',
    precentError: 'The premium price shall not be greater than 50.00%',
  },
  otcTrade: {
    warning: 'In order to ensure the security of the funds, the purchased assets will be locked for 24 hours before withdrawal is allowed but trading will not be affected.',
    inLine: 'Online',
    outLine: 'Offline',
    TransactionTimes: 'Number of transactions',
    CreditDegree: 'Credit',
    his: '(BTC) Historical transactions (equivalent to BTC)',
    price: 'Price ',
    volume: 'Amount ',
    TradingLimit: 'Limit ',
    TimeLimitPayment: 'Payment time limit ',
    MerchantRemarks: 'Merchant Remarks ',
    min: 'Minute',
    closeTitle: 'Close the ad',
    closeWarning: 'If you close the ad, you will not be able to make transactions in the future. Are you sure you want to close this ad ',
    goHall: 'Return',
    close: 'Close ad',
    PurchaseAmount: 'Purchase Amount ',
    AmountSale: 'Sale amount ',
    all: 'All ',
    pass: 'Fund password ',
    passError: ' Please enter 8 to 20 digits, including at least two of letters, numbers or characters',
    ImmediateSale: 'Sale immediately',
    ImmediatePurchase: 'Buy now',
    CountDown: 'Countdown',
    numberError: 'The order amount is greater than the order quantity',
    numberMinError: 'The number of exchanges must not be less than the minimum transaction limit',
    numberMaxError: 'The number of exchanges must not be greater than the maximum transaction limit',
    OrderAmount: 'Order amount',
    ScopeOrderAmount: 'Order amount range',
    QuantityInExchange: 'Exchange Quantity',
    use: 'Use',
    sell: 'Sell',
    buy: 'Buy',
    TransactionMode: 'Transaction Mode ',
    payment: 'payment method',
    Receivables: 'Receipt method',
    none: 'No',
  },
  otcDetailOrder: {
    goPay: 'Go to pay',
    CancellationOrder: 'Cancel the order',
    WaitingPayment: 'Wait for the payment from the other party',
    WaitingPuttingMoney: 'The other party is releasing money',
    ConfirmReleaseMoney: 'Confirm receipt and release money',
    SubmitAcomplaint: 'Submit a complaint',
    goHall: 'Return to the off-site hall',
    OrderClosed: 'Order closed',
    OrdersAppeal: 'Order appeal',
    CancellationComplaint: 'Cancel the complaint',
    OrderException: 'Order Exception ',
    ConfirmPayment: 'Confirm the payment ',
    MarkedAsPaid: 'Marked As Paid ',
    NotYetPaid: 'Not Yet Paid ',
    payWarning: 'This platform does not support automatic money deduction, please transfer money yourself to the above account',
    PaymentAmount: 'Payment Amount',
    PaymentReference: 'Payment Reference Number',
    Otherparty: 'Other party',
    ConfirmReleaseMoneyTitle: 'Cancel Order',
    ConfirmReleaseMoneyWarning: 'Please be sure to Login and confirm the receipt of the payment',
    pass: 'Fund password',
    passError: 'Please enter 8 to 20 digits, including at least two of letters, numbers or characters',
    ConfirmReleaseMoneyConfrim: 'I confirm that I have logged in to my payment account and checked the payment is correct',
    CancellationOrderTitle: 'Cancel the order',
    CancellationOrderWarning1: 'No refund will be given after canceling the order. If you have already paid, please do not cancel the order.',
    CancellationOrderWarning2: 'Cancellation Rule: If the buyer cancels 3 orders in total on one day, it will lead to the limit of the buying functions on that day',
    CancellationOrderConfrim: 'I confirm that I have not paid to the other party yet',
    AppealTitle: 'Appeals',
    AppealWarning: 'If the order encounters a dispute, it can be solved through the appeal channel.',
    ReasonsAppeal: 'Appeal reason',
    CancellationComplaintTitle: 'Cancel the appeal',
    CancellationComplaintConfrim: 'Cancel the complaint on your behalf without dispute. Do you want to confirm to cancel the complaint?',
    AppealTitleFive: 'The appeal can only be submitted 5 minutes after payment confirmation.',
    PendingPayment: 'Waiting for payment',
    CountdownPayments: 'Payment Countdown ',
    WaitingCountdownPayment: ' Waiting for the other party Countdown Payment ',
    MoneyCollected: 'Waiting for collection ',
    MoneyCollectedWarning: 'After the other party confirms the payment and releases the currency, you will receive the corresponding amount. ',
    otherPartyPaid1: 'The other party has paid',
    otherPartyPaid2: 'Marked as',
    otherPartyPaid3: 'Successful payment',
    Completedbuy1: 'Completed',
    Completedbuy2: 'You can pass',
    Completedbuy3: 'View assets',
    Completedbuy4: 'Transfer to the currency account for trading',
    CoCompletedbuy4: 'Transfer to the primary account for trading',
    Completedsell: 'Completed',
    TitleOrderClose: 'Order closed',
    TitleComplaint: 'Appealing',
    TitleComplaintText: 'Our customer service staff is actively working for you. Please be patient and wait for the results.',
    TitleOrderException: 'Order exception',
    AfterAppealbuy1: 'Completed',
    AfterAppealbuy2: 'You can pass',
    AfterAppealbuy3: 'View assets',
    AfterAppealbuy4: 'Transfer to the currency account for trading',
    CoAfterAppealbuy4: 'Transfer to the primary account for trading',
    AfterAppealsell: 'Completed',
    barText: 'Has been ordered',
    bar1Buy1: 'Waiting for payment',
    bar1Buy2: 'Waiting for collection',
    bar1Sell1: 'Waiting for collection',
    bar1Sell2: 'Waiting for releasing',
    bar2Buy1: 'Paid',
    bar2Buy2: 'Waiting for collection',
    bar2Sell1: 'Payment received',
    bar2Sell2: 'Waiting for releasing',
    bar3Buy1: 'Paid',
    bar3Buy2: 'Completed',
    bar3Sell1: 'Payment received',
    bar3Sell2: 'Completed',
    bar4Sell: 'Closed',
    bar5Sell: 'Appealing',
    bar7Sell: 'Exception Order',
    bar8Buy1: 'Paid',
    bar8Buy2: 'Completed',
    bar8Sell1: 'Payment received',
    bar8Sell2: 'Completed',
    day: 'Day',
    hour: 'Hour',
    min: 'Minute',
    sec: 'Seconds',
    SellersPaymentMethod: "Seller's payment method",
    paysBuy2: "You have paid, you can't view the other party's payment information",
    paysBuy3: "You have paid, you can't view the other party's payment information",
    paysSell3: 'Order has been completed, unable to view payment information',
    pays4: 'The order has been closed, unable to view payment information',
    pays5: 'The order is in the process of appealing, unable to view payment information',
    pays7: "The order is abnormal, can't view payment information,",
    paysBuy8: "You have paid, you can't view the other party's payment information",
    paysSell8: 'Order has been completed, unable to view payment information',
    MessPaymentReference: 'Payment Reference Number',
    MessPrice: 'Unit price',
    MessVolume: 'Volume',
    MessTotol: 'Total price',
    MessMerchantRemarks: 'Merchant Remarks',
    none: 'No',
    chatServer: 'Customer service',
    chatUser: 'Merchant',
    chatServerMessage: 'System Message: You have successfully submitted your appeal, please be patient.',
    chatServerInp: 'Please enter information',
    chatServerBut: 'Send',
    inline: 'Online',
    outline: 'Offline',
    chatVolume: 'Volume',
    chatUserInp: 'Please enter the information',
    chatUserBut: 'Send',
    identification: 'Real-name information',
    connection: 'Contact information',
    phone: 'Phone number',
    twoMin: 'The buyer can check it in 2 minutes after payment.',
  },
  components: {
    alert: {
      buttonText: 'I understood',
    },
    dialog: {
      confirmText: 'Confirm ',
      closeText: 'Cancel',
    },
    getCode: {
      button: 'SMS Code',
      after: 'Get it again',
    },
    select: {
      noData: 'No data',
    },
    otcReminder: {
      title: 'Reminder',
      text1: '1.Please check in details the transaction information of the other party before the transaction.',
      text2: '2.Please communicate through the platform and save the relevant chat records',
      text3: '3.If there is a transaction dispute, you can solve the problem by making a complaint.',
      text4: '4.If you have completed your payment, be sure to click the "I have paid" button and the seller will receive the digital asset upon confirmation of the payment.',
    },
  },
  mining: {
    minings: 'Trading Mining',
    already_output: 'Mining output',
    dividend_total_amount: 'Total amount of mine',
    dig_out: 'Mined amount',
    distribution: 'Pending accumulative mining outputs today',
    dividend_income: 'Accumulative equivalences of dividend income today',
    mining_output: 'Mining output yesterday',
    distribution_yesterday: 'Accumulative equivalences of dividend income yesterday',
    my_earnings: 'My income',
    invite_bonus: 'Invite dividends',
    total_earnings: 'Cumulative mining revenue',
    total_out: 'Cumulative mining output',
    mining_detail: 'Mining details today',
    amount_dividends: 'Pending dividend income today',
    bonus: 'Dividend yesterday',
    time: 'Time',
    trader_volume: 'Transaction amount equivalence',
    Produce: 'Output',
    state: 'State',
    coin: 'Currency',
    platform: 'Total platform charge',
    alreadyDivided: 'Divided',
    divided: 'Pending dividend',
    Return: 'Return',
    replaced: 'To be returned',
  },
  innov: {
    info: 'Basic Information',
    innov_tit: 'New Tokens',
    progress: 'Progress',
    rz_total: ' Total exchange',
    whole: 'ALL',
    have: 'Processing',
    dh_end: 'End of redemption',
    dh_financing: 'Successful redemption',
    end: 'Ended',
    financing: 'Successful',
    start: 'Time period',
    current: 'Progress：',
    Target: 'Target：',
    immediate: 'Exchange now',
    Innovation: 'New Tokens',
    purchase: 'Subscription No.',
    entry: '  Project Name',
    purchase_time: 'Time',
    purchase_amount: 'Paid Amount',
    obtain_token: 'Token Amount',
    state: 'Status',
    operation: 'Operation',
    Surplus: 'View details',
    numbre: 'Quantity',
    view_details: 'View details',
    Project_introduction: 'Project introduction',
    Token_money: 'Token information',
    accepted_currencies: 'Acceptable Currency：',
    Currency_symbol: 'Symbol：',
    Amount_raised: 'Exchange Account:',
    initial_price: 'Initial Price：',
    Start_time: 'Start Time：',
    End_time: 'End Time：',
    Amount_already: 'Exchanged Amount',
    Current_progress: 'Progress：',
    Purchase_quantity: 'Subscribed Quantity：',
    Wallet_balance: 'Balance Available：',
    SMS_code: 'SMS Verification code：',
    Get_code: 'Get code',
    Google_code: 'Google authentication code：',
    cancel: 'Cancel',
    Only: 'This project should hold  ',
    Hold: 'Hold now',
    requires: 'The project requires real-name verification',
    Authenticate: 'Verification',
    token: 'Token Subscription succeeded. Tokens will be given after financing.',
    closed: 'Subscription failed. Financing closed',
    fulfilled: 'Subscription successful. Financing fulfilled',
    get_it: 'Get it',
    error_1: 'Depositing EOS to BikiCoin requires BOTH a deposit address and a EOS deposit memo. WARNING: Failure to follow the correct EOS deposit procedure will result in the lost deposits.',
    error_2: 'EOS address only accepts EOS deposit. Any other assets deposited to EOS address will be irretrievable.',
    error_3: 'Deposit to EOS address requires 1 confirmation.',
    error_4: 'The input amount is greater than the wallet amount, please input again',
    error_5: 'Please enter the amount',
    error_6: 'Please enter the Google authentication',
    error_7: 'Please enter the SMS verification code',
    error_8: 'Application amount need to be no less than 0.1',
    Whois: 'Inquire Who is information',
    nodata: 'No Data',
    binding: 'Please link your phone number or open up google authentication.',
    bindAlter: 'Please turn on mobile phone verification or email verification in account management',
    status1: 'Preheating',
    status2: 'Processing',
    status3: 'Recruitment completed',
    status4: 'Issue TOKEN',
    status5: 'Refund of subscription fund',
    viewInfo1: 'Individual purchasable quantity (range)',
    viewInfo2: 'Individual purchase (min)',
    spend: 'Participate in the project needs to consume: ',
    currentBalance: 'Currently available',
    spendTip: '(Please refer to the activity details)',
    holdPositions: 'Positions',
    averageHoldPositions: 'Average Positions',
    purchaseLimitation: 'Purchase limit',
    or: 'or',
    and: 'and',
    timeHold: 'Hold',
    canParticipateExchange: 'Can participate in redemption',
    lowerThanMinAmount: 'The amount of the exchange cannot be less than',
    higherThanMaxAmount: 'Single exchange amount cannot be greater than',
    balanceNotEnough: 'Insufficient balance',
    surplusExchangeAmount: 'Your remaining convertible amount is',
  },
  manageFinances: {
    manage_finances: 'Financial treasure',
    subTitle: 'Automatic diversification of investment tools, saving time and effort',
    record: 'Financial records',
    day: 'Day',
    recommend: 'Recommended',
    safe: 'Security',
    expected: 'Expected',
    rate: 'The yield',
    timeLimit: 'Time limit',
    people: 'm',
    join: 'The cumulative join',
    now: 'Immediately make money',
    yearRate: 'Annual',
    dayRate: 'Daily',
    moreProducts: 'See more products',
    Repayment: 'Reimbursement means',
    ReleaseCycle: 'Release cycle',
    deadline: 'Project deadline',
    startTime: 'Start time for counting interest',
    exitTime: 'Exit time',
    times: 'Time',
    availableBalance: 'Available balance',
    goRecharge: 'Deposit',
    buyNumber: 'Purchase quantity',
    feature: 'Your expected earnings',
    commonProblem: 'Common problems',
    buyNow: 'Buy now',
    what: 'What is a treasure?',
    what_1: 'What is BitMore?',
    how: 'How to participate?',
    rule: 'Return rules for wealth management products?',
    rule_1: 'BitMore return rule?',
    forSafe: 'For the security of your account, please open the real-name verification first.',
    goAuth: 'To verify',
    note1: 'Financial treasure, launched by biki platform, is a fixed cycle financial coin product based on digital assets. Each plan has corresponding lock-in period and expected annual income, you can buy according to different needs. The principal will be locked after purchase and interest will be calculated from the agreed time. When the plan expires, the principal and income are unfrozen and transferred to the account, and you get the agreed income..',
    note1_1: 'Bitmore, launched by WBFex platform, is a fixed cycle financial coin product based on digital assets. Each plan has corresponding lock-in period and expected annual income, you can buy according to different needs. The principal will be locked after purchase and interest will be calculated from the agreed time. When the plan expires, the principal and income are unfrozen and transferred to the account, and you get the agreed income..',
    note2: 'Log into the official website of Biki digital asset exchange www.biki.com, click "go to finance" button in asset management, select the product you need according to your own situation, enter the amount of bitcoin, and click "join now" to participate in wealth management.',
    note2_1: 'Log into the official website of WBFex Digital Asset Exchange new.WBFex.com, click on the "go to finance" button in asset management, select the products you need according to your own situation, enter the number of currencies, click "join immediately" to participate in BitMore',
    note3: 'According to the rule of paying interest first and then principal, the first return period is three weeks in the product lock-in period, three times of interest will be returned after three weeks, and then the interest will be returned once a week, and the principal will be returned after the product expires.',
    inputNumber: 'Please enter the purchase quantity',
    buyNumMax: 'The purchase quantity shall not exceed the available balance',
    first: 'Interest first and then principal',
    together: 'Principal and interest together',
    buyTime: 'Buy time',
    name: 'The project name',
    orderNumber: 'The order number',
    coin: 'Currency',
    number: 'The number of',
    tablerate: 'Interest rate (%)',
    status: 'State',
    operating: 'Operation',
    transferTime: 'Return of time',
    returnCoin: 'Return the currency',
    returnNumber: 'Return the number of',
    type: 'Type ',
    allType: 'All types of',
    subscribed: 'Have subscribed',
    interested: 'In the draw',
    completed: 'Has been completed',
    interest: 'Interest',
    principal: 'The principal',
  },
  footer: {
    terms: 'Terms',
    agreement: 'Terms of Service',
    declaration: 'Legal Notices',
    aboutChainup: 'About',
    utils: 'Tool',
    about: 'About us',
    apply: 'Coin application',
    download: 'APP Downloads',
    api: 'API documentation',
    media: 'Social media',
  },
  appDownLoad: {
    title: 'Mobile App Download',
    desc: 'Multi-Platform Terminal Trading At Anytime and Anywhere',
    platform: [
      'iPhone',
      'Android',
    ],
    twoDimension: 'Scan here to download',
    headerCode: 'Scan to download APP',
    flag: [
      {
        title: 'Flash Trades',
        desc: 'The platform provides a more convenient trading experience, including a variety of transaction types, quick order matching and one click trading.',
      },
      {
        title: 'Easy transfer of assets',
        desc: 'Easily transfer assets in your account, real-time digital asset overview, and currency ratio pie chart',
      },
      {
        title: 'Custom trading panel',
        desc: 'Freely define trading layout according to different trading habits, including K line and depth chart entry',
      },
      {
        title: 'Account integrated management',
        desc: 'An account with multiple security verifications and multiple currencies',
      },
    ],
    setUp: {
      title: 'iOS user installation tutorial',
      step: [
        {
          step: 1,
          title: 'App Download ',
          desc: 'Open the settings function in your phone and select "General";',
        },
        {
          step: 2,
          title: 'Equipment management',
          desc: 'In General, select the "Profile and Device Management" feature;',
        },
        {
          step: 3,
          title: 'Choose to install',
          desc: 'In the enterprise-level application category in the description file and device management, select the file name of the enterprise application to be installed (consistent with the prompt when opening), and click to enter;',
        },
        {
          step: 4,
          title: 'Set trust',
          desc: 'After entering the company signature page, after confirming the company name and application name in the company signature, click Trust "Enterprise Signature Company Name";',
        },
        {
          step: 5,
          title: 'Launch the app',
          desc: 'Go back to the desktop and re-open the app to use it.',
        },
      ],
    },
    setUpTestFlignt: {
      title: 'iOS user installation tutorial',
      step: [
        {
          step: 1,
          title: 'App Download ',
          desc: 'Click [Install TestFlight] and follow the instructions to open the APP Store to download TestFlight.',
        },
        {
          step: 2,
          title: 'TestFlight Download',
          desc: 'You can also download TestFlight directly from the App Store if you have already downloaded it, please ignore.',
        },
        {
          step: 3,
          title: 'Choose to install',
          desc: 'Open TestFlight APP to accept the Cobidex Beta version to open; if you have already downloaded it for [Update] to get the latest version.',
        },
      ],
    },
  },
  homeTemplate: {
    text_01: 'Anytime, anywhere, multi-platform trading',
    text_02: 'Covers multiple platforms of iOS, Android, Windows, Mac, and supports full business functions',
    text_03: 'Download apps',
    text_04: 'Products and Services',
    text_05: 'Secure, trusted digital asset trading and asset management services to millions of users worldwide',
    text_06: 'Globalization layout',
    text_07: 'Several countries set up localized trading service centers to create a multi-service form',
    text_08: 'Security system',
    text_09: 'First class team creates professional security and multiple defense to protect your assets',
    text_10: 'Trading System',
    text_11: 'Establishing localized transaction service centers in multiple countries to create multi-services',
    text_12: 'High scalability',
    text_13: 'The fast flow of assets is unimpeded',
    text_14: 'Open a trading trip right away',
    text_15: 'Provide comprehensive digital asset business such as currencies exchange and contract transactions',
    text_16: 'Sign up now',
  },
  lever: {
    leverAccount: 'Leveraged assets',
    leverKy: 'Available',
    leverKj: 'Can borrow',
    leverYj: 'Lent',
    leverjd: 'Loans',
    fxl: 'Risk rate',
    leverText1: 'Total assets/Loan assets*100%',
    leverText2: 'When the risk rate is ≤110%, the account will trigger a short position to return the borrowed funds.',
    bcj: 'Explosive price',
    leverHz: 'Transfer',
    leverJd: 'Loans',
    leverZded: 'Maximum amount',
    leverLl: 'Interest rate',
    all: 'All',
    leverJdcc: 'Successful loan',
    leverJdNumber: 'Number of loans',
    buy: 'Buy/Do more',
    sell: 'Sell/Short',
    alertTitle: 'Tips',
    your: 'Your',
    alertTet: 'The balance of leverage account is insufficient. Please transfer assets to leverage account for leverage tradings',
    hzBtntext: 'Transfer immediately',
  },
  contract: {
    co: 'Swaps',
    co2: 'Swaps',
    contractType1: 'Perpetual',
    contractType2: 'This Week',
    contractType3: 'Next Week',
    contractType4: 'Monthly',
    contractType5: 'Quarterly',
    applies: 'Change',
    height: 'High',
    low: 'Low',
    H_volume: '24hr Vol',
    handicap: 'Orderbook',
    latestDeal: 'Recent Trades',
    number: 'Amount',
    price: 'Price',
    total: 'Total',
    time: 'Time',
    volume: 'Volume',
    addEnsure: 'Increase Margin',
    minusEnsure: 'Reduce Margin',
    fqEnsure: 'Allocated Margin',
    kyEnsure: 'Available Margin',
    addMinusEnsure: 'Increase & Decrease margin',
    addEnsureNumbere: 'Increase Margin Amount',
    minusEnsureNumbere: 'Reduce the amount of margin',
    infoOrder: 'Limit',
    marketOrder: 'Market price orders',
    cancel: 'Cancel',
    closePrice: 'Market price closing',
    limitPrice: 'Limit price closing',
    contractId: 'Swaps ID',
    accounttId: 'Position ID',
    coNumber: 'Number of Positions',
    Piece: 'Piece',
    holding: 'Open Positions',
    currentEntrust: 'Current Orders',
    dayTrading: 'Fills',
    historyEntru: 'Order History',
    nowList1: 'Time',
    nowList2: 'Swaps',
    nowList3: 'Size',
    nowList4: 'Order Price',
    nowList5: 'Filled',
    nowList6: 'Remaining',
    nowList7: 'Value',
    nowList8: 'Average Price',
    nowList9: 'Type',
    nowList10: 'State',
    nowList11: 'Close Position',
    nowList12: 'Exec Price',
    nowList13: 'Entry Price',
    nowList14: 'Tag price',
    nowList15: 'Liquidation Price',
    nowList16: 'Unrealized PNL',
    nowList17: 'Realized PNL',
    nowList18: 'Rate',
    nowList19: 'Margin',
    nowList20: 'Order ID',
    status1: 'New Order',
    status2: 'Complete Deal',
    status3: 'Partial Deal',
    status4: 'Cancelled',
    status5: 'Revoked',
    status6: 'Deprecated',
    status7: 'Partial transaction has been revoked',
    c_success: 'Order Complete',
    cancel_success: 'Cancel Complete',
    c_error: 'Operation failed',
    cost: 'Cost',
    orders: 'Order Value',
    balance: 'Available Balance',
    entryPrice: 'Entry Price',
    liquidationPrice: 'Liquidation Price',
    bjPrice: 'Mark Price',
    liquidationPriceTwo: 'Estimated Margin call price',
    Value: 'Value',
    Chiccw: 'Your Position',
    Multipleb: 'Leverage',
    marketPrice: 'Market Price',
    cw: 'Position',
    rate: 'ROE',
    buyButton: 'Buy/Long',
    sellButton: 'Sell/Short',
    loginReg: 'Log In/Sign up',
    buy: 'Buy',
    sell: 'Sell',
    errorText_01: 'The maximum number of positions can be entered',
    errorText_02: 'The minimum number of positions can be entered',
    limitPriceTrade: 'Limit price',
    marketPriceTrade: 'Market price',
    piece: 'Piece',
    value: 'Value',
    chiccw: 'Your Position',
    multipleb: 'Leverage',
    deliveryTime: 'Time left for delivery',
    day: 'Day',
    success: 'Successful',
    pleprice: 'Please enter the closing price',
  },
  japanese: {
    goRegister: 'Sign Up',
    exchangeTop: {
      title: 'Top 10 in the Japan Stock Exchange',
      desc: 'Make payment more convenient and comfortable',
      types: [
        'Coins',
        'Markets',
      ],
    },
    registerStep: {
      title: 'The account opening process will be steadily advanced',
      desc: 'Complete the registration process within 3 minutes',
      stepList: [
        {
          title: 'Sign up with your email address',
          desc: 'Easily sign up with an email address. Registration is completed in 30 seconds!',
        },
        {
          title: 'Simple',
          desc: 'Basic information registration',
        },
        {
          title: 'Go to the transaction page when the input is complete',
          desc: 'The verification postcard arrives in approximately 2 to 3 days',
        },
      ],
    },
    accountStep: {
      title: 'The account opening process will be steadily advanced',
      desc: 'Account opening process',
      stepList: [
        {
          title: 'Application',
          desc: 'Can be opened via pc or app account',
        },
        {
          title: 'Verify identidy',
          desc: 'After applying, we will send you a verification email.',
        },
        {
          title: 'Start trading',
          desc: 'Start trading immediately after entering your PIN on your ID card',
        },
      ],
    },
    qa: {
      title: 'Common question answer',
      desc: 'Please refer to the FAQ',
      q: [
        'Q1   How long does it take to open an account?',
        'Q2   How long do I need to deposit after opening an account?',
        'Q3   Can I deposit or withdraw foreign currency?',
        'Q4   Is there an age limit when opening an account?',
        'Q5   I only have a smartphone, can I trade?',
      ],
      a: [
        'Business can be carried out within 1 to 2 working days after receiving the account completion notice (※ simple registered mail).',
        'There is no time limit for payment.',
        'Foreign currency deposits and withdrawals are not supported.',
        'Customers over the age of 20 can open an account.',
        'Some features cannot be used with a PC, but you can trade with your smartphone.',
      ],
    },
  },
  korea: {
    goTrade: '去交易',
    login: '登录',
    noticeInfo: '公告',
    types: [
      'Coins',
      'Market',
    ],
    authenticate: {
      title: '国际专业认证',
      desc: '使用ISMS和ISO认证的安全系统来保护资产',
      system: {
        title: '信息安全管理系统（ISMS）',
        desc: '사산 좌석 자세한 파악 사산 좌석',
      },
      iso: {
        title: 'ISO / IEC 27001,27017,27208',
        desc: '사산 좌석 자세한 파악 사산 좌석',
      },
    },
    service: {
      center: {
        title: '客户服务中心',
        time: '（근무일9:00-18:00）',
      },
      online: {
        title: '在线顾客服务',
        desc: '网上聊天工具的使用及顾客沟通',
        time: '（근무일9:00-18:00）',
      },
      download: {
        title: '下载使用',
      },
    },
  },
  europe: {
    regester: {
      title: 'Want to Start trading right away?',
      desc: 'Register your account immediately and start trading.',
      goRegister: 'Register',
      placeHolder: 'Enter Mailbox/Mobile Number',
    },
    product: {
      title: 'Create your cryptocurrency portfolio today',
      desc: 'Multiple Advantages, Best Trading Platform',
    },
    productDetail: [
      {
        title: 'Lightning trading performance',
        desc: 'Provide a variety of transaction type selection, order speed combination',
      },
      {
        title: 'Custom trading panel',
        desc: 'Freely define trading layout according to different trading habits',
      },
      {
        title: 'Easy asset switching',
        desc: 'Easily transfer assets in your account, real-time digital asset overview',
      },
      {
        title: 'Account integration settings',
        desc: 'Multiple security verification settings, one account management',
      },
    ],
    serviceDetail: {
      title: 'ChainUP Products And Services',
      desc: 'Providing secure and reliable digital asset trading and asset management services to millions of users worldwide',
      list: [
        'Globalization Layout',
        'Trading system',
        'Secuity system',
        'High scalability',
      ],
    },
  },
  tradeLimt: {
    tradeLimit_text_everyDayCount: 'The currency pair limits the number of daily transactions,',
    tradeLimit_text_everyDayBuy: 'The maximum purchase amount per day is:',
    tradeLimit_text_everyDaySell: 'The maximum selling amount per day is:',
    tradeLimit_text_noLimitBuy: 'Unrestricted buy transaction',
    tradeLimit_text_noLimitSell: 'Unrestricted sell transaction',
    tradeLimit_text_instructions: 'Trading instructions',
    tradeLimit_text_everyDayBuy_end: ' ',
    tradeLimit_text_everyDaySell_end: ' ',
  },
  market: {
    allMarket: 'All Markets',
    text1: 'Situation',
    text2: 'Trading',
    text3: 'Basic information',
    vol: 'Vol',
  },
  kyc: {
    success: '提交成功',
    error: '认证失败',
    text1: '无法达到认证要求，请返回个人中心重新提交实名申请',
    text2: '账号已存在实名认证信息，不能再提交实名申请。',
    text3: '被认证的实名信息不能重复认证',
    text4: '您的信息已提交，审核时长为1分钟，您可以在“用户中心”页面查看结果。',
  },
  weeks: {
    0: 'Sunday',
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday',
  },
  months: {
    0: 'January',
    1: 'February',
    2: 'March',
    3: 'April',
    4: 'May',
    5: 'June',
    6: 'July',
    7: 'August',
    8: 'September',
    9: 'October',
    10: 'November',
    11: 'December',
  },
  mobilityTrade: {
    addPrice: 'Please enter the amount',
    addVolume: 'Please enter the quantity',
    priceSell: 'Sold by amount',
    smallAmount: 'Small amount 0 transaction fee',
    tradeType: 'Type',
    immediately: 'One-click buy coins',
    immediatelyBuy: 'One-click purchase',
    immediatelySell: 'One-click sell',
    priceBuy: 'Purchase by amount',
    volumeBuy: 'Buy by quantity',
    volumeSell: 'Sold by quantity',
    referencePrice: 'Reference  price',
    referenceWarn: 'Price is reference only. The price is calculated by the mainstream currency of the exchanges. ',
    coin: 'Currency',
    legal: 'Fiat currency',
    all: 'All',
    buyPayments: 'Choose payment method',
    sellPayments: 'Choose payment method',
    addPayments: 'Add a payment method',
    noPayments: "If there's no payment method, please visit Me to setup.",
    tradePrice: 'Unit price',
    tradeVolume: 'Quantity',
    tradeSum: 'The amount actually paid',
    warn: 'Due to market fluctuations the price may be slightly fluctuated. Please place your order ASAP to lock the price.',
    btnHis: 'Quote has expired, Please click to get the latest price',
    warn1: 'Enter the purchase amount ',
    warn2: 'Enter the purchase quantity',
    warn3: 'Enter the sell amount ',
    warn4: 'Enter the sell quantity',
    error1: 'The maximum order amount ',
    error2: 'The range of order amount',
    error3: 'The maximum order quantity ',
    error4: 'The number of orders placed',
    error5: 'No suitable quotation found, please modify the order conditions',
    error6: 'Please add the payment method first.',
  },
  freeStaking: {
    incomeFilter: [
      'Receiving earnings',
      'Locked Quantity',
      'Principal release',
    ],
    home: {
      status: [
        'Pending',
        'Locking',
        'Pending interest',
        'Calculating interest',
        'Finished',
        'Principal release',
        'Fulfilled the quota',
        'Finished',
      ],
      notice: 'Notice',
      title: 'Staking',
      gainRate: 'Annualized returns',
      lockDay: 'Locking period',
      lockProgress: 'Locking process',
      takeActivity: 'Detail',
      contactUS: 'Contact Us',
      FQA: 'FAQ',
      income: 'Financial income',
    },
    detail: {
      activityProgress: 'Process',
      lockAllNum: 'Total locking amount',
      lockNum: 'Locked Quantity',
      lockMinNum: 'Minimum quantity per lock ',
      lockMaxNum: 'Maximum cumulative lock quantity',
      userLocked: 'Locked  quantity',
      twoDayIncome: [
        'days',
        'Prospective earnings：',
      ],
      totalGainAmount: 'Cumulative grantings',
      totalUserGainAmount: 'Earned',
      rulesDangers: 'I am fully aware of the project risks',
      agreePOS: 'Agree to PoS',
      activityStatus: [
        'Locking starts at',
        'Locking ends at',
        'Interest starts at',
        'Interest ends at',
        'Principal release',
      ],
      incomeTime: 'Time on earnings received',
      incomeNum: 'Quantity on earnings received',
      incomeDetail: 'Details on earnings received',
      balanceError: [
        'The locking quantity should be less than the quantityof ',
        ' in your account',
      ],
      buyAmountMinError: [
        'Minimum quantity per lock',
      ],
      buyAmountMaxError: [
        'Maximum cumulative lock quantity',
      ],
      buySuccess: 'Purchase succeeded',
    },
    myPos: {
      lockPosTable: [
        'Coin',
        'Locking starts at',
        'Locked Quantity',
        'Estimated annual interest rate',
        'Current locked earnings',
        'PoS status',
      ],
      unLockPosTable: [
        'Coin',
        'Date on earnings received',
        'Principal',
        'Annual interest rate',
        'Quantity of receiving earnings',
      ],
      lockPOS: 'PoS locked',
      havePOS: 'PoS position',
      endTime: 'Deadline',
    },
  },
  gameAccount: {
    TotalAssets: 'Game assets value',
    tabnav1: 'Game assets',
    tabnav2: 'Game props',
    sidetext1: 'Game account',
    sidetext2: 'Exchange account',
    context1: 'The name of the game',
    context2: 'Coin',
    context3: 'Holding amount',
    context4: 'Game coins deposit',
    context5: 'Game coins withdrawal',
    context6: 'Submitted',
    context7: 'Failed',
    context8: 'Succeed',
    context9: 'Payment information',
    context10: 'Top up coins',
    context11: 'Deposit status',
    context12: 'Withdrawal time',
    context13: 'Withdrawal coins',
    context14: 'Withdrawal information',
    context15: 'Withdrawal status',
    promptText: 'Amount of payment',
    promptText1: 'SMS verification code',
    promptText2: 'Please enter a 6-digit verification code of your mobile phone.',
    promptText3: 'Game coins',
    promptText4: 'Maximum withdrawal',
    promptText5: 'Maximum deposit',
    promptText6: 'Choose the withdrawal game',
    promptText7: 'Choose the deposit game',
    promptText8: 'Select a withdrawal method',
    promptText9: 'Select a payment method',
    promptText10: 'Withdraw the coins in the game into digital currency and save it to the game center account. Withdrawal requires an application, which will be passed immediately after the staff verified that the funds were normal. <br> Withdrawal time: 9:00 ~ 21:00.',
    promptText11: 'The withdrawal digital currency should be subject to the real-time price of the exchange at the time of withdrawal.',
    promptText12: ' Only the digital currency stored in the game center account can be converted into in-game coins. The digital currency in the exchange account cannot be exchanged directly. Please transfer the digital currency assets to the game center account first.',
    promptText13: 'The digital currency used for topping up is subject to the real-time price of the exchange at the time of topping up.',
    promptText14: 'Fund flow',
    promptText15: 'Game Account',
    promptText16: 'gital currency',
  },
  gameCenter: {
    center: 'Game center',
    enterGame: 'Enter the game',
    transfer: 'Coins transfer',
    deposit: 'Game deposit',
    holdNum: 'Holding amount',
    price: 'The value of game coins',
    hotGame: 'Hot games',
    myGame: 'My game',
    myAccount: 'My game assets',
    goApp: 'Please go to APP to play the game',
    win7Data1: 'Win7 Game',
    win7Data2: 'Invest Yourself',
    win7Data3: 'Join Now',
    win7Data4: 'Number',
    win7Data5: 'Prize pool',
  },
  brokerSystem: {
    homeText: [
      'Welcome',
      'Total number of invites',
      'Cumulative rebate',
    ],
    otherText: [
      'Rebate coin',
      'Swaps type',
      'Copy the lin',
      'Settlement status',
      'Rebate type',
      'Invitee level',
    ],
    updateTime: '*Update the data once a day',
    navTab: [
      'The general situation of  performanc',
      'Income of commission',
      'Subordinate detail',
      'Transactional inquiry',
      'Promotion   assista',
    ],
    commissionNavTab: [
      'Details of accumulated incom',
      'Commission settlement record',
    ],
    commissionTable: [
      'Date',
      'Rebate coin',
      'Level 1 rebate',
      'Secondary rebate',
      'Accumulated  commissio',
      'Status',
      'Settled',
      'Rebate type',
      'Rebate amount',
      'Rebate ratio',
      'Settled',
      'Unsettlement',
      'First-level inviter',
      'Second inviter',
    ],
    lowerNavTab: [
      'Subordinate details',
      'Rebate detai',
    ],
    lowerTable: [
      'Registration time',
      'UID',
      'Account',
      'Name',
      'Type',
      'Invitation metho',
      'Rebate type for the superior',
      'Accumulated rebate',
      'Subordinate income of dividen(USDT)',
      'Rebate details',
      'Cumulative transaction amount',
      'Subordinate UID',
      'View details',
    ],
    lowerTable1: [
      'Date',
      'Rebate type',
      'Rebate coin',
      'Amount of commission',
      'Rebate ratio',
      'Transaction details',
      "Invitee's transaction amount(USDT)",
      'Trading currency pairs',
      'Transaction amount',
    ],
    tradeSearchNavTab: [
      'Subordinate transaction details',
    ],
    tradeSearchTable: [
      'Swaps',
      'Average transaction price',
      'Volume of transacti',
      'Type',
      'Transaction fee coin',
      'Fee',
      'Rebate ratio',
      'Amount of commissio',
      'Options',
      'Open position',
    ],
    invite: [
      'Promotion assistant  1 _ Friend invitation',
      'Promotion assistant 2 _ Bonus invitation',
    ],
    inviteStyle: [
      'PC invitation',
      'H5 invitation',
      'Home bonus entrance',
      'Prepare bonus',
      'Issue bonus',
    ],
    inviteInfo: [
      ',You can send the link to the user or group you want to invite . Users can open the  invitation link and register to become your subordinate users and contribute to your rebate',
      'Click  the bonus  on the APP homepage to issue the bonus  to the target invited users . You can set the bonus   as   “new users only”.   After the user registers to receive the bonus, he   (she )  can become your subordinate user and contribute  to your rebate',
    ],
    overview: [
      'Rebate profit',
      'Assets conversion will be updated every two hours   in real time',
      'Accumulated conversion(USDT)',
      'Conversion of yesterday(USDT)',
      'Conversion  of the day before yesterday(USDT)',
      'Compare previous day',
      'Proportion of accumulated  rebates',
      'Rebate within the last we',
      'General situation of clients',
      'Total clients (people)',
      'Direct brokers',
      'Sub-brokers',
      'Dividend user s of yesterday (people)',
      "Subordinate yesterday's trading volume(USDT)",
      'Subordinate Natural Monthly Trading Volume(USDT)',
    ],
    overviewTitle: [
      'Return Commission',
      'Sub Commission',
      'Spots broker',
      'Swaps broker',
    ],
    overviewList: [
      'Ranking',
      'Account',
      'Rebate fee (USDT)',
    ],
    lowerTableList: [
      'Rebate',
      'Dividen',
      'Friend invitation',
      'Bonus invitation',
      'Return Commission',
      'Sub Commission',
    ],
    weeks: [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ],
    charts: [
      'Direct broker',
      'Sub-broker',
    ],
  },
  singPassLogin: {
    mainText1: 'Other login methods',
    mainText2: 'SingPass, a third-party login',
    mainText3: 'The QR code is invalid',
    mainText4: 'Please click refresh',
    mainText5: 'Open',
    mainText6: 'Moblie phone SingPass',
    mainText7: 'Scan code to login',
    mainText8: 'No SingPass App yet?',
    mainText9: 'Go download',
    mainText10: 'You have not associated it with the exchange account, please select the associated method.',
    mainText11: 'Associate with a new account',
    mainText12: 'Associate with current account',
    mainText13: 'Log in and associate with the SingPass account',
    mainText14: 'Register and associate with the SingPass account',
    mainText15: 'SingPass, a third-party Register',
  },
  registerOptions: {
    title: 'Safety reminder',
    text: 'Due to the unstable network of the operator, SMS reception may be delayed in your current region. It is recommended that you use Google authentication',
    conf: 'Bind Google',
    close: 'Still bound to phone',
  },

  futures: {
    currentSymbol: {
      title1: 'Mark Price',
      title2: 'Index Price',
      title3: 'Funding Rate',
      title4: 'Estimated Rate',
      title5: '24H Volume',
      explain1: 'Mark price is used to calculate PNL and liquidation.<br /> Mark price may offset from the latest market price, in case of market manipulation',
      explain2: 'Underlying fair value in spot market.',
      explain3: ' Funding rate used to settle end of term.',
      explain4: 'Current funding rate calculated by last term, used to settle end of term.<br />Positive means long positions pay funding fee to short positions, vice versa.',
      explain5: ' estimated funding rate for settlement',
      explain6: 'Positive means long positions pay funding fee to short positions, vice versa.',
      marginModel1: 'Cross',
      marginModel2: 'Isolated',
    },
    depth: {
      text1: 'Order Book',
      text2: 'Trades',
      text3: 'Index',
      text4: 'Depth',
      text5: '标记',
      theadList1: 'Price',
      theadList2: 'Amount',
      theadList3: 'Sum',
    },
    market: {
      text1: 'Contract',
      text2: 'Last Price',
      text3: 'Change',
      text4: 'USDT',
      text5: 'Coin',
      text6: 'Mixed',
      text7: 'Demo',
      text8: 'Search',
    },
    newTrade: {
      text1: 'Trades',
      text2: 'Price',
      text3: 'Amount',
      text4: 'Time',
    },
    orderList: {
      tabType1: 'Positions',
      tabType2: 'Limit Order',
      tabType3: 'Stop Order',
      tabType4: 'Order History',
      tabType5: 'Transaction History',
      subTabType1: 'All',
      subTabType2: 'TP Order',
      subTabType3: 'SL Order',
      a_columns_1: 'Contract',
      a_columns_2: 'Side',
      a_columns_3: 'Volume',
      a_columns_4: 'Filled Rate',
      a_columns_5: 'Order Price',
      a_columns_6: 'Filled Price',
      a_columns_7: 'Type',
      a_columns_8: 'Reduce Only',
      a_columns_9: 'Time',
      a_columns_10: 'Operation',
      b_columns_1: 'Contract',
      b_columns_2: 'Side',
      b_columns_3: 'Trigger Price',
      b_columns_4: 'Order Price',
      b_columns_5: 'Volume/Value',
      b_columns_6: 'Type',
      b_columns_7: 'Reduce Only',
      b_columns_8: 'Place Time',
      b_columns_9: 'Expiration Time',
      c_columns_1: 'Contract',
      c_columns_2: 'Type',
      c_columns_3: 'Side',
      c_columns_4: 'Order Price',
      c_columns_5: 'Volume/Value',
      c_columns_6: 'Deal Volume',
      c_columns_7: 'Average Price',
      c_columns_8: 'P/L',
      c_columns_9: 'Status',
      c_columns_10: 'Time',
      c_columns_11: 'Commission',
      d_columns_1: 'Time',
      d_columns_2: 'Type',
      d_columns_3: 'Amount',
      d_columns_4: 'Coin',
      typeStatus1: 'Limit Order',
      typeStatus2: 'Market Order',
      typeStatus3: 'Post Only',
      typeStatus4: 'Liquidation',
      typeStatus5: 'Merge positions',
      getStatus1: 'New Order',
      getStatus2: 'Full-filled',
      getStatus3: 'Partial-filled',
      getStatus4: 'Cancelled',
      getStatus5: 'Cancelling',
      getStatus6: 'Abnormal',
      getStatus7: 'Partial-filled and Cancelled',
      sideT1: 'Open',
      sideT2: 'Close',
      sideT3: ' Short',
      sideT4: ' Long',
      mPrice: 'Market Price',
      isclose1: 'Yes',
      isclose2: 'No',
      cancel: 'Cancel',
      allCancel: 'Cancel All',
      tstext1: 'Please',
      tstext2: 'Login/Register',
      tstext3: 'to operation',
      memoText1: 'Cancelled by user',
      memoText2: 'The order was canceled by the system because of an exception',
      memoText3: 'Liquidated，unfilled order is cancelled by system',
      memoText4: 'Insufficient opponents, the order was cancelled by the system',
      memoText5: 'FOK Order, fully filled or cancelled by system',
      memoText6: 'IOC order，filled immediately or cancelled by system',
      memoText7: 'Post only, Taker order will be cancelled by system',
      memoText8: 'The order has been cancelled because the position no longer exists',
      newText1: ' Profit and loss record',
      newText2: 'Trading Record',
      newText3: 'Open position price',
      newText4: 'Average Close Price',
      newText5: 'Number of Positions',
      newText6: 'Realized profits and losses',
      newText7: 'The total profit and loss is the total profit and loss that occurred during the holding period of the position, and the total profit and loss = handling fee + capital cost + position profit and loss + Loss sharing',
      newText8: 'Cumulative total handling fee for opening and closing positions',
      newText9: 'Funding Fee',
      newText10: 'Total funding costs during the holding period',
      newText11: 'The position profit and loss is the sum of the position profit and loss for each time the position is closed, ',
      newText12: 'Share',
      newText13: 'Close Time',
      newText14: ' role',
      newText15: 'Position profit and loss',
      newText16: 'Only the current contract',

    },
    tradeForm: {
      mPrice: 'Market',
      textjz: 'Value',
      text1: 'Place Order',
      text2: 'Available',
      text3: 'Available used to open orders/positions.<br />Available is used as cross margin first, when loss happens, availalble decrease',
      text4: 'Term of Validity',
      text5: 'Cost',
      text6: 'R/O',
      text7: 'Reduce only order is used to close position, not open new position.',
      text8: 'Price',
      text9: 'Volume',
      text10: 'Cont.',
      text11: 'Price',
      text12: 'Trigger',
      text13: 'When latest price went through trigger price, stop order will be activated to place',
      text14: 'Open Value',
      text15: 'Open position value，O/V = Amount * Price.<br />Actual dealed amount is related to deal price',
      text16: '4 Hour',
      text17: '7 Day',
      text18: '14 Day',
      text19: '30 Day',
      text20: 'Open',
      text21: 'Close',
      text22: 'Limit Order',
      text23: 'Market Order',
      text24: 'Stop Order',
      text25: 'Available',
      text26: 'Available',
      text27: 'Max Buy',
      text28: 'Max Sell',
      text29: 'P/O',
      text30: 'Order posted only',
      text31: 'Order immediately filled or cancelled',
      text32: 'Order filled or killed',
      text33: 'Open contract trade',
      text34: 'Login to trade',
      text35: 'Close Short',
      text36: 'Close Long',
      text37: 'Open Long',
      text38: 'Open Short',
      text39: 'Buy Long',
      text40: 'Sell Short',
      text41: 'Too much price deviation',
      text42: 'Exceed single order amount limit, max amount ',
      text43: 'Below single order amount limit, min amount ',
      text44: 'Exceed single order volume limit, max volume ',
      text45: 'Below single order volume limit, min volume ',
      text46: 'Exceed close available!',
      text47: 'Price',
      text48: 'Volume',
      text49: 'Open Value',
      text50: 'Trigger Price',
      text51: 'Insufficient Balance',
      text52: 'Market Price',
      text53: 'Volume',
      text54: 'Can not change when orders exist',
      text55: 'There are currently entrusted/positions in this contract, and position types cannot be adjusted',
      text56: 'Beyond the maximum order, you can also order a maximum of',
      text57: 'Beyond the biggest order amount',
    },
    calculator: {
      text1: 'Calculator',
      text2: 'Leverage Level',
      text3: 'Maximum holding amount',
      text4: 'Calculate',
      text5: 'Result',
      text6: 'Margin Balance',
      text7: 'Return',
      text8: 'ROI',
      text9: 'Close Price',
      text10: 'Can not reach this return rate',
      text11: 'Liquidation Price',
      text12: 'Open Price',
      text13: 'Close Price',
      text14: 'Amount',
      text15: 'Cont',
      text16: 'Profit/Loss',
      text17: 'Long',
      text18: 'Short',
      text19: 'Buy Long',
      text20: 'Sell Short',
      text21: 'Amount',
      text22: 'Margin Balance',
      text23: 'Insufficient Balance',
      text24: 'will not be liquidated',
    },
    depositMode: {
      text1: 'Cross mode: All positions use the whole cross account balance to avoid to be liquidated.<br />If liquidation happens,cross positions and  cross balance will be lost.',
      text2: 'Isolated mode:Some balance is allocated to the isolated account.<br />When isolated balance is below maintenance margin, the isolated positions will be liquidated.<br />In this mode, Margin balance can be increased or decreased.',
      text3: 'Switch to Cross Mode',
      text4: 'Switch to Isolated Mode',
      text5: 'Login to operate',
      text6: 'Cross Mode',
      text7: 'Isolated Mode',
      text8: 'Can not change,when positions or orders exist',
      text9: 'Cross',
      text10: 'Isolated',
      text12: ' Margin Mode',
    },
    reminder: {
      text1: 'Trigger Price',
      text2: 'Price',
      text3: 'Do not notice again, reset in [Preferences]',
      text4: 'Amount',
      text5: 'Volume',
      text6: 'Balance Used',
      text7: 'Order Balance',
      text8: 'Limit Order',
      text9: 'Market Order',
      text10: 'Stop Order',
    },
    lever: {
      text1: 'Leverage Level',
      text2: 'Max Level',
      text3: 'Max holding amount is about',
      text4: 'Confirm',
      text5: 'Login to operate',
      text6: 'Can not change when orders exist',
      text7: 'Contract Leverage Level',
      text8: 'Min level can not be below',
    },
    openFutures: {
      titleText: 'Futures risk confirmation',
      confirmText: 'I understand the risks',
      text1: '1. Your position margin may be insufficient due to the changeable market. Please keep in mind that the exchange Swap will place a forced liquidation order and send you liquidation details according to the system agreement.',
      text2: '2. Please read carefully and follow the business rules of the exchange Swap. Understand the contract mechanism and operation principle, understand the various risks of the market, and reasonably arrange funds for trading.',
      text3: '3. Under certain extreme market conditions, it may be difficult or impossible to close out your open positions. For example, when your profit ranks first in the effective contract PnL in the entire contract market, and the insurance fund is insufficient to cover the losses.',
      text4: '4. In case of changes in local laws, regulations and policies, amendments to exchange trading rules, and introduction of emergency measures, the exchange Swap will notice you in advance that you may not maintain open positions, but the position margin and profitable balance will still be paid!',
      text5: '5. For any reasons beyond the control of the exchange, such as earthquakes, floods, fire and other force majeure factors or computer system and communication system failures, etc., your order may not be executed in part or in whole, and you may suffer losses therefrom.',
      text6: '6. Like speculative transactions, hedging transactions also face risks caused by price fluctuations. Please understand the relevant mechanism in advance.',
      text7: '7. If you lend your account to a third party, the safety of your contract deposit may be affected. Please carefully protect your personal account.',
    },
    positionLis: {
      columns1: 'Contract',
      columns2: 'Total/Available',
      columns3: 'Cost',
      columns4: 'Mark Price',
      columns5: 'Liquidation Price',
      columns6: 'Margin',
      columns7: 'Margin Rate',
      columns8: 'Return/ROI',
      columns9: 'Quick Close',
      columns10: 'TP/SL',
      text1: 'Price',
      text2: 'Limit Close',
      text3: 'Market Close',
      text4: 'Amount',
      text5: 'Cont',
      text6: 'Total:Total amount held in this contract.<br />Available:Amount is available to close.<br /> Positive means long, negative means short.',
      text7: 'Position average deal price',
      text8: 'Mark price is used to calculate PNL and liquidation.<br />Mark price may offset from the latest market price, in case of market manipulation',
      text9: ' When mark price is close to liquidation price, position will be liquidated',
      text10: 'Margin Balance.',
      text11: 'The ratio of the secured assets of this position to the value of the position. When the margin rate <= maintenance margin rate + taker rate for liquidation, the position will be forced to liquidate.',
      text12: 'Accumulative P/L =（Mark Price - Cost）* amount。<br /> Return of Investment(ROI)= P/L / Margin Balance。',
      text13: 'TP/SL orders mean: Set trigger conditions in advance.<br />When orders trigged, orders place.<br />TP/SL help to preserve profit or cut down loss.',
      text14: 'Cross',
      text15: 'Isolated',
      text16: 'Short',
      text17: 'Long',
      text18: 'Please input order price',
      text19: 'Please input order amount',
      text20: 'Exceed the close available',
      text21: 'Close Long',
      text22: 'Close Short',
      text23: 'Market Price',
      text24: 'Amount',
      text25: 'Cont.',
      text26: 'Settled profit and loss',
      text27: 'Realized profit and loss is the income that has been settled into the user s balance,including transaction fees, capital costs, liquidation profit and loss, settlement income, etc.',
      text28: 'Fees',
      text29: 'Realized profits and losses',
      text30: 'Funding Fee',
      text31: 'Position settlement',
      text32: 'Share',
    },
    setFutures: {
      titleText: 'Preferences',
      text1: 'Position Mode',
      text2: 'Can not change when any position or order exists',
      text3: 'Netting Mode',
      text4: 'Only buy or sell side position exists in netting mode',
      text5: 'Hedging Mode',
      text6: 'Both buy and sell side position can exist in hedging mode',
      text7: 'Confirm before place order',
      text8: 'Enable',
      text9: 'Disable',
      text10: 'Contract unit',
      text11: 'Cont.',
      text12: 'Confirm',
      text13: 'Stop orders preference',
      text14: 'Second confirmation of order',
    },
    setMarginCoin: {
      titleText: 'Modify Isolated Margin Balance',
      text1: 'Current',
      text2: 'After',
      text3: 'Amount',
      text4: 'Margin Balance',
      text5: 'Actual Leverage Level',
      text6: 'Liquidation Price',
      text7: 'Available',
      text8: 'Available',
      text9: 'Total',
      text10: 'Increase',
      text11: 'Decrease',
      text12: 'Increase Margin Balance',
      text13: 'Decrease Margin Balance',
      text14: 'Insufficient balance to increase',
      text15: 'Insufficient balance to decrease',
    },
    stopOrder: {
      titleText: 'Take Profit and Stop Loss Setting',
      text1: 'Take Profit',
      text2: 'Cancel all TP orders',
      text3: 'TP Trigger/Order Price > Mark Price',
      text4: 'TP Trigger/Order Price  < Mark Price',
      text5: 'Estimated PNL',
      text6: 'Estimated ROI',
      text7: 'Stop Loss',
      text8: 'Cancel all SL orders',
      text9: 'Liquidation Price < SL Trigger/Order Price < Mark Price',
      text10: 'Mark Price < SL Trigger/Order Price < Liquidation Price',
      text11: 'Estimated PNL',
      text12: 'Estimated ROI',
      text13: 'Trigger Price',
      text14: 'Order Price',
      text15: 'Order Amount',
      text16: 'Cont.',
      text17: 'Trigger Price',
      text18: 'Order Price',
      text19: 'Please input order amount',
      text20: 'Price',
      text21: 'TP price must be above mark price！',
      text22: 'TP price must be below mark price！',
      text23: 'SL price must be below mark price！',
      text24: 'SL price must be above liquidation price！',
      text25: 'SL price must be above mark price！',
      text26: 'SL price must be below liquidation price！',
      text27: 'Too large price deviation！',
      text28: 'Exceed close volume available！',
      text29: 'Term of validity',
      text30: 'Market',
      columns1: 'Contract',
      columns2: 'Total/Available',
      columns3: 'Cost',
      columns4: 'Mark Price',
      columns5: 'Liquidation Price',
      columns6: 'TP Trigger',
      columns7: 'Order Price ',
      columns8: 'Order Amount',
      columns9: 'SL Trigger',
      columns10: 'Latest Price',
      time1: '24H',
      time2: '7 Day',
      time3: '14 Day',
      time4: '30 Day',
    },
    order: {
      startTime: 'Start',
      endTime: 'End',
      coType: 'Type',
      coSide: 'Side',
      contract: 'Contract',
      orderType: 'Type',
      cancelAll: 'Cancel All Orders',
      title1: 'Current Order',
      title2: 'Stop Order',
      title3: 'Limit Order History',
      title4: 'Stop Order History',
      title5: 'Trade History',
      typeList1: 'Perpetual',
      typeList2: 'Demo',
      typeList3: 'Mixed',
      sideType1: 'USDT',
      sideType2: 'Coin',
      all: 'Total',
      orderType1: 'Limit Order',
      orderType2: 'Market Order',
      orderType3: 'Post Only',
      orderType4: 'IOC',
      orderType5: 'FOK',
      orderType6: 'Liquidation',
      orderType7: 'Merge positions',
      time: 'Time',
      side: 'Side',
      intrustPrice: 'Order Price',
      intrustVolume: 'Order Amount(Cont.)',
      dealVolume: 'Deal Amount(Cont.)',
      dealPrice: 'Average Price',
      priceDeal: 'Deal price',
      onlyCut: 'Reduce Only',
      opera: 'Operation',
      triggerPrice: 'Trigger Price',
      intrustVolumeOrNum: 'Order Amount/Value',
      overTime: 'Expiration Time',
      status: 'Status',
      submitTime: 'Place time',
      triggerTime: 'Triggered Time',
      roles: 'Role',
      fee: 'Commission',
      status1: 'New Order',
      status2: 'Full-filled',
      status3: 'Partial-filled',
      status4: 'Cancelled',
      status5: 'Cancelling',
      status6: 'Abnormal',
      status7: 'Partial-filled and Cancelled',
      contractType1: 'Perpetual',
      contractType2: 'Current week',
      contractType3: 'Next week',
      contractType4: 'Monthly',
      contractType5: 'Quarterly',
      statusText1: 'Valid',
      statusText2: 'Expiration',
      statusText3: 'Finished',
      statusText4: 'Trigger Failed',
      open: 'Open',
      close: 'Close',
      buy: 'Long',
      sell: 'Short',
      currentPrice: 'Market Price',
      yes: 'Yes',
      no: 'No',
      per: 'Cont.',
      cancel: 'Cancel',
      memoText1: 'Cancelled by user',
      memoText2: 'Over the period of validity',
      memoText3: ' has reached',
      memoText4: ' trigger price, but the entrustment cannot be submitted due to insufficient margin, and the execution fails',
      memoText5: 'trigger price, but the entrustment cannot be submitted due to insufficient margin, and the execution fails',
      memoText6: ' trigger price, the execution fails due to position forced liquidation.',
      memoText7: ' trigger price, the assignment cannot be submitted as the tradingoperation is suspended,execution fails',
    },
    coFlowingWater: {
      startTime: 'Start',
      endTime: 'End',
      coin: 'Coin',
      type: 'Type ',
      all: 'Total',
      transferIn: 'Deposit',
      transferOut: 'Withdrawal',
      fee: 'Funding Fee',
      loss: 'Amortization',
      time: 'Time',
      amount: 'Amount',
      typeList1: 'Handling fee sharing',
      typeList2: 'Bonuses',
      typeList3: 'Bonus recycling',
      typeList4: 'Closing fee',
      typeList5: 'Open warehouse fee',

    },
    coAccount: {
      coAccount: 'Contract Account',
      transfer: 'Transfer',
      coin: 'Coin',
      canUser: 'Available',
      allBalance: 'Total Balance',
      allMargin: 'Cross Balance',
      subMargin: 'Isolated Balance',
      lockMargin: 'Frozen Balance',
      opera: 'Operation',
    },
    transfer: {
      transfer: 'Balance Transfer',
      from: 'From',
      to: 'To',
      coin: 'Coin',
      volume: 'Quantity',
      volumeError: 'Insufficient Quantity',
      all: 'Total',
      canTransfer: 'Available',
      confirm: 'Confirm',
      cantIn: 'Deposit Restricted',
      cantOut: 'Withdrawal Restricted',
      exchangeAccount: 'Spot Account',
      coAccount: 'Contract Account',
      noBonus: 'Bonus is not include',
      bonusNote: 'The trading bonus cannot be withdrawn directly, but the profitable part could.The trading bonus can be used for opening positions, paying trading fees, funding fee and the settlement for closing positions. The trading bonus will be deducted at the end for paying fee or position loss.',
      text1: '您当前有合约赠金',
      text2: '系统将强制保留赠金在账户中',
      text3: '盈利部分可自由划转',
    },
    assets: {
      text1: 'Assets',
      text2: 'Infomation',
      text3: 'Transfer',
      text4: 'More',
      text5: 'Account MR',
      text6: 'AMR = Total Balance / Open Positions Value.<br />This value is used to gauge the account risk approximately.<br />Margin rate goes smaller, the liquidation risk goes bigger',
      text7: 'Total assets',
      text8: 'Total equity of this margin coin.<br />Total Balance = Cross Balance + Isolated Balance + Frozen Balance',
      text9: 'Cross Balance',
      text10: 'Cross Balance. When cross is liquidated, the balance will be lost.<br />Notice: Balance transfered to contract account will be as Cross Balance automatically',
      text11: 'Isolated Balance',
      text12: 'Isolated Balance. Separated from cross account or other isolated account.<br />When liquidations occur, balance in cross and isolated accounts  are without interference',
      text13: 'Frozen Balance',
      text14: 'Total frozen balance of unfilled limit orders',
      text15: 'Contract Name',
      text16: 'Delivery Date',
      text17: 'Contract Underlying',
      text18: 'Index',
      text19: 'Margin Coin',
      text20: 'Contract Par Value',
      text21: 'Tick',
      text22: 'Min MMR',
      text23: 'Settlement cycle',
      text24: [
        'Perpetual',
        'Weekly',
        'Bi-Weekly',
        'Monthly',
        'Quarterly',
      ],
      text25: 'Historical Data',
    },
    assetsChart: {
      text1: 'Isolated',
      text2: 'Cross',
      text3: 'Frozen',
    },
  },
  agent: {
    title: 'Partner',
    teamNum: 'Team size',
    totalRewards: 'Total rewards',
    nickName: 'Nickname',
    regTimme: 'Registration date',
    account: 'Registration ID',
    authStatus: 'Certification status',
    holdAmount: 'Coins in team acct.',
    id: 'ID',
    tradeTime: 'Trading time',
    tradeUID: 'Trading UID',
    backAmount: 'Rebate',
    authed: 'Certified',
    unAuth: 'Uncertified',
  },
  gridTrade: {
    hours: 'Hours',
    title: 'Grid trading',
    type1: 'Custom policy',
    type2: 'AI policy',
    btn1: 'Open policy',
    btn2: 'Open AI policy',
    setText1: 'Available',
    setText2: 'Price range',
    setText3: 'Lower',
    setText4: 'Upper',
    setText5: 'The number of grids',
    setText6: 'Arithmetic',
    setText7: 'Geometric',
    setText8: 'Profit per grid',
    setText9: 'Trading Fee deducted',
    setText10: 'Investment',
    setText11: 'TP Price',
    setText12: 'SL Price',
    setText13: 'Use the original',
    aiText1: 'Seven-day annualized yield',
    error1: 'Price range is too small. Please reset.',
    error2: 'Number range: 2-100',
    error3: 'Insufficient balance',
    error4: 'The investment per grid is too small',
    error5: 'Take profit price must be higher than grid upper price',
    error6: 'Stop loss price must be less than grid lower price',
    error7: 'Take profit price must be higher than current price',
    error8: 'Stop loss price must be less than current price',
    error9: 'The profit per grid is too small, please reset it',
    orderType1: 'Processing',
    orderType2: 'Completed',
    tip: 'Trading Notes',
    tipContent: 'After terminating the grid, all uncompleted orders will be cancelled. Are you sure you want to terminate this grid trading?',
    clounms1: 'Total Investment',
    clounms2: 'Grid profit',
    clounms3: 'Position Gain And Loss',
    clounms4: 'Annualized yield',
    clounms5: 'Running time',
    close: 'terminating',
    tab1: 'Grid details',
    tab2: 'Processing',
    tab3: 'Completed',
    dialog1: 'Grid profit',
    dialog2: 'Annualized yield',
    dialog3: 'Position Gain And Loss',
    dialog4: 'Grid type',
    dialog5: 'Initial investment',
    dialog6: 'Commission time',
    dialog7: 'Buy',
    dialog8: 'Bid price',
    dialog9: 'Ask price',
    dialog10: 'Sell',
    dialog11: 'Ask price',
    optional: 'OPT',
    least: 'You need at least',
    cancelTip: "The order is a grid strategy order,the order can't cancelled manually. Please stop the grid and operate again",
    clinchPrice: 'transaction amount',
  },
  futuresData: {
    navTitle: 'Historical Data',
    typeTabList1: 'USDT-M Futures',
    typeTabList2: 'Coin-M Futures',
    typeTabList3: 'Mixed-M Futures',
    typeTabList4: 'Demo Futures',
    promptText1: 'Coins',
    promptText2: 'Type',
    promptText3: 'Contracts',
    tabList1: 'Insurance Fund',
    tabList2: 'Funding Rate',
    tabList3: 'Index Price',
    tabList4: 'Mark Price',
    columns1: 'Time',
    columns2: 'Type',
    columns3: 'Amount',
    columns4: 'Contracts',
    columns5: 'Funding Rate',
    columns6: 'Exchange',
    columns7: 'Weight',
    tbaleTitle1: 'Activities',
    tbaleTitle2: 'Historical Data',
    tbaleTitle3: 'Source Exchanges',
    moreText1: 'Learn more about insurance fund',
    moreText2: 'Learn more about funding rate',
    moreText3: 'Learn more about index price',
    moreText4: 'Learn more about mark price',
    text1: 'The insurance fund balance of {USDT} margined perpetual',
    text2: 'Liquidation deposit',
    text3: 'Amortizatoin withdrawal',
  },
  minings: {
    infoAll1: 'URP',
    infoAll2: 'Details',
    infoAll3: 'Total Issued',
    infoAll4: 'Issuance Cap',
    infoAll5: 'How it works',
    infoAll6: 'Total Transaction Fees Rebate',
    infoAll7: 'Current Tier Rebate',
    infoAll8: 'Total Transaction Fees Rebate',
    infoAll9: 'Today’s Rebate',
    tab1: 'Current Tier',
    tab2: 'Next Tier',
    after1: 'Current Tier Vol',
    after2: 'Current Tier URP',
    after3: 'Current Tier Issued',
    after4: 'The Remaining VD',
    after5: 'Next phase issue Vol.',
    after6: 'My Super Rep',
    after7: 'Become a Super Rep',
    after8: 'Vote for a Super Rep',
    after9: 'Total Mining',
    myInfo1: 'Total Transaction Fee',
    myInfo2: 'Today’s Mining',
    myInfo3: 'Today’s Transaction Fee',
    tablist1: 'Mining Record',
    tablist2: 'Bonus for Super Rep',
    returnList1: 'Transaction Fee',
    returnList2: 'Mining Earnings',
    returnList3: 'Date',
    returnList4: 'Trading account ',
    returnList5: 'Dividend',
    returnList6: 'My Rebate',
  },
  vote: {
    title1: 'Tier ',
    title2: ' Super Rep Election',
    startTime: 'Start-End Time',
    searchText: 'Search Candidates',
    search: 'Search',
    rule: 'Voting rules',
    info1: 'Candidates',
    info2: 'Current Votes',
    info3: 'Vote',
    tabelBtn1: 'Vote for him',
    tabelBtn2: 'End',
    dialogTitle: 'Remind',
    dialogTip1: 'Confirm to give',
    dialogTip2: 'a vote？',
  },
  miningfee: {
    title: 'USDT  Reserve Pool（URP）',
    balance: 'Balance',
    name: 'Account name',
    vdexAccount: 'USDT  Reserve Pool（URP）',
    uid: 'Storage account UID',
    num: 'VD Amount',
    info: 'Storage rules for service fee',
    ethAddress: 'Chain Address',
  },
  kzhome: {
    title: 'Proof of Work of Trading Mining',
    desc: ' ',
    what: 'What is Vdust?',
    whatA: "When the new trading mine Cobidex reaches the tenth level, the miners’ difficulty will increase quickly. In order to motivate miners, the principle of proof of work (POW) is used to reward miners with Vdust from the eleventh level onwards. Unlike POW in the traditional sense, Vdust does not require complicated calculations or electricity, and the reward is based on the contribution of miners' transaction fees.",
    feature: 'Vdust is not dust!',
    featureText1: 'Each contribution of 1 USDT of handling fee to URP (USDT Reserve Pool) releases one Vdust',
    featureText2: 'The URP (USDT Reserve Pool) will release one Vdust',
    featureText3: 'The upper limit of Vdusts is 10,000,000,000, until the end of mining.',
    featureText4: 'mine them until they are gone',
    featureText5: 'Vdust uses the ERC20 public chain to reward miners through smart contracts.',
    featureText6: 'rewarding miners through smart contracts',
    title2: 'Allocation Ratio',
    totalText: 'Circulating Supply:',
    total: '10,000,000,000',
    totalText2: 'Total Supply:',
    total2: '10,000,000,000',
    name: 'Miners',
    memberVip: 'Super Representatives',
    knowName: 'Cobidex Team',
    falseText: 'Note: The super representatives and Cobidex team will each receive 1% initially, which can be used to reward users in various promotions.',
    target: 'Our goal is to make Vdust a universal gift coin worldwide.',
    solusion: 'As an offshoot, Vdust does not own any URP shares. Its price is generated by consensus.',
    actionText: 'Mine Vdust now!',
  },
  landingPage: {
    main_title1: '完成注册送100 矿渣币',
    main_title2: '新交易矿',
    main_title3: '交易就是挖矿 秒变可升值资产',
    main_download: '立即下载APP',
    main_text1: '美国MSB数字货币交易注册登记  受美国司法管辖',
    main_text2: '安全、透明、公链发行',
    never_title: '万万没想到 他们是这么赚钱的！',
    never_item1_title: '要么发财 要么平庸',
    never_item1_text1: '2021年2月',
    never_item1_text2: '2021年3月',
    never_item1_text3: '2021年11月',
    never_item1_text4: '2021年4月份',
    never_item1_text5: '4月1日',
    never_item1_text6: '4月15日',
    never_item1_text7: '4月16日',
    never_item1_text8: '12月31日',
    never_item1_text9: '你还在等什么？',
    never_item2_title: '新交易矿是什么？',
    never_item2_text1: '交易手续费存入USDT储蓄池（URP）变资产',
    never_item2_text2: '边交易，边挖矿',
    never_item2_text3: '每一个Cobidex底层资产都锚定USDT',
    never_item2_text4: '挖矿不用电 现在就体验！',
    level_title: '每级底层资产递增',
    level_text1: '每级挖矿资产翻倍',
    level_text2: '第一级: 2 USDT',
    level_text3: '第二级: 1 USDT',
    level_text4: '第三级: 4 USDT',
    level_text5: '第四级: 8 USDT',
    level_text6: '第五级: ........',
    presentive1: '超级代表代候选人',
    presentive2: '请到',
    presentive3: '为他们投票',
  },
  creditCard: {
    title: 'Credit Card',
    amount: 'Purchase quantity',
    num: 'Purchase Amount(Excluding service charge)',
    buy: 'Buy',
    mark: 'MoonPay makes buying cryptocurrencies simpler, faster and safer for everyone. It accepts all major debit / credit cards and new mobile payment methods like Apple Pay.',
    warnTit: 'Please Note',
    warn1: '1.The crypto amount quoted is based on the current rate and is not final. If the rate changes by more than +/-2.5% you will be asked to reconfirm the transaction via email from MoonPay',
    warn2: 'Once payment is completed, you can check your $<payment status>$ on MoonPay or $<Payment Overview>$ on Exchange',
    warn3: '3.If you have any questions, please contact MoonPay customer support. (support@moonpay.io)',
    confirmTit: 'Go to MoonPay to pay',
    confirmBtn: 'Leaving Exchange to MoonPay',
    confirmText1: 'MoonPay will transfer the crypto to your Exchange account in 2 ~ 10 mins, after MoonPay payment is completed .',
    confirmText2: 'MoonPay is a separate platform owned by a third party, and Exchange does not assume any responsibility for any loss or damage caused by the use of the credit card payment service.',
    callBackTit: 'MoonPay Payment feedback',
    callBackTrue: 'To Trade',
    callBackFalse: 'View assets',
    callBackText1: '1.When the payment is complete, you will receive an email from MoonPay. You can check the $<payment status>$ in MoonPay',
    callBackText2: '2.After the payment is completed, MoonPay will recharge to your currency account by recharging.',
    callBackText3: '3.If you have any questions, please contact MoonPay customer support. (support@moonpay.io)',
  },
};
